function PlanP({ ...props }) {
	return (
		<g id="plan-p">
			<g id="furniture">
				<polyline
					points="430.9 629.2 428.53 629.2 428.53 624.51 430.9 624.51 430.9 629.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="204.21"
					y1="509.79"
					x2="68.97"
					y2="509.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.21"
					y1="517.95"
					x2="204.21"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.21"
					y1="512.17"
					x2="202.02"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.61"
					y1="512.17"
					x2="192.92"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.5"
					y1="512.17"
					x2="183.81"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="180.4"
					y1="512.17"
					x2="174.71"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="171.3"
					y1="512.17"
					x2="165.61"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.19"
					y1="512.17"
					x2="156.5"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="153.09"
					y1="512.17"
					x2="147.4"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="143.99"
					y1="512.17"
					x2="138.3"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="134.88"
					y1="512.17"
					x2="129.19"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="125.78"
					y1="512.17"
					x2="120.09"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="116.68"
					y1="512.17"
					x2="110.99"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="107.57"
					y1="512.17"
					x2="101.88"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="98.47"
					y1="512.17"
					x2="92.78"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.37"
					y1="512.17"
					x2="83.68"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="80.26"
					y1="512.17"
					x2="74.57"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="71.16"
					y1="512.17"
					x2="68.97"
					y2="512.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="68.97"
					y1="512.17"
					x2="68.97"
					y2="517.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.03"
					y1="552.47"
					x2="686.72"
					y2="552.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="719.55"
					y1="588.02"
					x2="725.24"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="728.65"
					y1="588.02"
					x2="734.34"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.76"
					y1="588.02"
					x2="743.45"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.86"
					y1="588.02"
					x2="752.55"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.96"
					y1="588.02"
					x2="761.65"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.07"
					y1="588.02"
					x2="770.76"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.17"
					y1="588.02"
					x2="779.86"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.27"
					y1="588.02"
					x2="788.96"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.38"
					y1="588.02"
					x2="798.07"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="801.48"
					y1="588.02"
					x2="807.17"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.58"
					y1="588.02"
					x2="816.27"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="819.69"
					y1="588.02"
					x2="825.38"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="828.79"
					y1="588.02"
					x2="834.48"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.89"
					y1="588.02"
					x2="843.58"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="847"
					y1="588.02"
					x2="852.69"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.1"
					y1="588.02"
					x2="861.79"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.2"
					y1="588.02"
					x2="870.89"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.31"
					y1="588.02"
					x2="880"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.41"
					y1="588.02"
					x2="889.1"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.51"
					y1="588.02"
					x2="898.2"
					y2="588.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.03"
					y1="569.72"
					x2="931.03"
					y2="564.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.03"
					y1="560.62"
					x2="931.03"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="931.03"
					y1="554.83"
					x2="928.93"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="925.51"
					y1="554.83"
					x2="919.82"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.41"
					y1="554.83"
					x2="910.72"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.31"
					y1="554.83"
					x2="901.62"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="898.2"
					y1="554.83"
					x2="892.51"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.1"
					y1="554.83"
					x2="883.41"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="880"
					y1="554.83"
					x2="874.31"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.89"
					y1="554.83"
					x2="865.2"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="861.79"
					y1="554.83"
					x2="856.1"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.69"
					y1="554.83"
					x2="847"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.58"
					y1="554.83"
					x2="837.89"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="834.48"
					y1="554.83"
					x2="828.79"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.38"
					y1="554.83"
					x2="819.69"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.27"
					y1="554.83"
					x2="810.58"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.17"
					y1="554.83"
					x2="801.48"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="798.07"
					y1="554.83"
					x2="792.38"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.96"
					y1="554.83"
					x2="783.27"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="779.86"
					y1="554.83"
					x2="774.17"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="770.76"
					y1="554.83"
					x2="765.07"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.65"
					y1="554.83"
					x2="755.96"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="554.83"
					x2="746.86"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.45"
					y1="554.83"
					x2="737.76"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="734.34"
					y1="554.83"
					x2="728.65"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.24"
					y1="554.83"
					x2="719.55"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="716.14"
					y1="554.83"
					x2="710.45"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="707.03"
					y1="554.83"
					x2="701.34"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="697.93"
					y1="554.83"
					x2="692.24"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="688.82"
					y1="554.83"
					x2="686.72"
					y2="554.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="605.98 546.02 605.98 482.01 669.99 482.01 669.99 546.02 605.98 546.02"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="309.02 165.86 269.02 165.86 269.02 170.99 309.02 170.99 309.02 165.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="267.15 165.39 310.89 165.39 310.89 165.86 267.15 165.86 267.15 165.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="267.15"
					y1="165.39"
					x2="310.89"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.89"
					y1="165.39"
					x2="310.89"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.89"
					y1="165.86"
					x2="267.15"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.15"
					y1="165.86"
					x2="267.15"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.02"
					y1="170.99"
					x2="269.02"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.02"
					y1="165.86"
					x2="309.02"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="313.22 170.99 309.02 170.99 309.02 165.86 313.22 165.86 313.22 170.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="313.22"
					y1="170.99"
					x2="309.02"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.02"
					y1="170.99"
					x2="309.02"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.02"
					y1="165.86"
					x2="313.22"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.22"
					y1="165.86"
					x2="313.22"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="264.82 165.86 269.02 165.86 269.02 170.99 264.82 170.99 264.82 165.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="264.82"
					y1="165.86"
					x2="269.02"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.02"
					y1="165.86"
					x2="269.02"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.02"
					y1="170.99"
					x2="264.82"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.82"
					y1="170.99"
					x2="264.82"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="309.02"
					y1="166.79"
					x2="269.02"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="315.08 170.52 313.22 170.52 313.22 165.86 310.89 165.86 310.89 165.39 315.08 165.39 315.08 170.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="315.08"
					y1="170.52"
					x2="313.22"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.22"
					y1="170.52"
					x2="313.22"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="313.22"
					y1="165.86"
					x2="310.89"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.89"
					y1="165.86"
					x2="310.89"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="310.89"
					y1="165.39"
					x2="315.08"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.08"
					y1="165.39"
					x2="315.08"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="262.95 165.39 267.15 165.39 267.15 165.86 264.82 165.86 264.82 170.52 262.95 170.52 262.95 165.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="262.95"
					y1="165.39"
					x2="267.15"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.15"
					y1="165.39"
					x2="267.15"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.15"
					y1="165.86"
					x2="264.82"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.82"
					y1="165.86"
					x2="264.82"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.82"
					y1="170.52"
					x2="262.95"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.95"
					y1="170.52"
					x2="262.95"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="260.58 166.79 260.58 169.16 164.6 169.16 164.6 166.79 260.58 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="260.58"
					y1="166.79"
					x2="260.58"
					y2="169.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="260.58"
					y1="169.16"
					x2="164.6"
					y2="169.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="164.6"
					y1="169.16"
					x2="164.6"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="164.6"
					y1="166.79"
					x2="260.58"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="315.08 166.79 319.83 166.79 319.83 181.01 315.08 181.01 315.08 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="319.83"
					y1="166.79"
					x2="315.08"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.83"
					y1="181.01"
					x2="319.83"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.08"
					y1="181.01"
					x2="319.83"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="315.08"
					y1="166.79"
					x2="315.08"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="258.21 166.79 262.95 166.79 262.95 181.01 258.21 181.01 258.21 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="262.95"
					y1="166.79"
					x2="258.21"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="262.95"
					y1="181.01"
					x2="262.95"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.21"
					y1="181.01"
					x2="262.95"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="258.21"
					y1="166.79"
					x2="258.21"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="162.23 166.79 166.97 166.79 166.97 181.01 162.23 181.01 162.23 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="166.97"
					y1="166.79"
					x2="162.23"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="166.97"
					y1="181.01"
					x2="166.97"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.23"
					y1="181.01"
					x2="166.97"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.23"
					y1="166.79"
					x2="162.23"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="578.28 165.86 538.27 165.86 538.27 170.99 578.28 170.99 578.28 165.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="536.4 165.39 580.14 165.39 580.14 165.86 536.4 165.86 536.4 165.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="536.4"
					y1="165.39"
					x2="580.14"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.14"
					y1="165.39"
					x2="580.14"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.14"
					y1="165.86"
					x2="536.4"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.4"
					y1="165.86"
					x2="536.4"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.28"
					y1="170.99"
					x2="538.27"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.27"
					y1="165.86"
					x2="578.28"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="582.47 170.99 578.28 170.99 578.28 165.86 582.47 165.86 582.47 170.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="582.47"
					y1="170.99"
					x2="578.28"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.28"
					y1="170.99"
					x2="578.28"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.28"
					y1="165.86"
					x2="582.47"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.47"
					y1="165.86"
					x2="582.47"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="534.07 165.86 538.27 165.86 538.27 170.99 534.07 170.99 534.07 165.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="534.07"
					y1="165.86"
					x2="538.27"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.27"
					y1="165.86"
					x2="538.27"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="538.27"
					y1="170.99"
					x2="534.07"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.07"
					y1="170.99"
					x2="534.07"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="578.28"
					y1="166.79"
					x2="538.27"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="584.34 170.52 582.47 170.52 582.47 165.86 580.14 165.86 580.14 165.39 584.34 165.39 584.34 170.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="584.34"
					y1="170.52"
					x2="582.47"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.47"
					y1="170.52"
					x2="582.47"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="582.47"
					y1="165.86"
					x2="580.14"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.14"
					y1="165.86"
					x2="580.14"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.14"
					y1="165.39"
					x2="584.34"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.34"
					y1="165.39"
					x2="584.34"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="532.2 165.39 536.4 165.39 536.4 165.86 534.07 165.86 534.07 170.52 532.2 170.52 532.2 165.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="532.2"
					y1="165.39"
					x2="536.4"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.4"
					y1="165.39"
					x2="536.4"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.4"
					y1="165.86"
					x2="534.07"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.07"
					y1="165.86"
					x2="534.07"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.07"
					y1="170.52"
					x2="532.2"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.2"
					y1="170.52"
					x2="532.2"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="529.83 166.79 529.83 169.16 448.99 169.16 448.99 166.79 529.83 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="529.83"
					y1="166.79"
					x2="529.83"
					y2="169.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="529.83"
					y1="169.16"
					x2="448.99"
					y2="169.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.99"
					y1="169.16"
					x2="448.99"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.99"
					y1="166.79"
					x2="529.83"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="584.34 166.79 589.08 166.79 589.08 181.01 584.34 181.01 584.34 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="589.08"
					y1="166.79"
					x2="584.34"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="181.01"
					x2="589.08"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.34"
					y1="181.01"
					x2="589.08"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="584.34"
					y1="166.79"
					x2="584.34"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="527.47 166.79 532.2 166.79 532.2 181.01 527.47 181.01 527.47 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="532.2"
					y1="166.79"
					x2="527.47"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.2"
					y1="181.01"
					x2="532.2"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.47"
					y1="181.01"
					x2="532.2"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="527.47"
					y1="166.79"
					x2="527.47"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="446.62 166.79 451.36 166.79 451.36 181.01 446.62 181.01 446.62 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="451.36"
					y1="166.79"
					x2="446.62"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.36"
					y1="181.01"
					x2="451.36"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.62"
					y1="181.01"
					x2="451.36"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.62"
					y1="166.79"
					x2="446.62"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="862.62 165.86 822.61 165.86 822.61 170.99 862.62 170.99 862.62 165.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="820.75 165.39 864.48 165.39 864.48 165.86 820.75 165.86 820.75 165.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="820.75"
					y1="165.39"
					x2="864.48"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.48"
					y1="165.39"
					x2="864.48"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.48"
					y1="165.86"
					x2="820.75"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.75"
					y1="165.86"
					x2="820.75"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.62"
					y1="170.99"
					x2="822.61"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.61"
					y1="165.86"
					x2="862.62"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="866.82 170.99 862.62 170.99 862.62 165.86 866.82 165.86 866.82 170.99"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="866.82"
					y1="170.99"
					x2="862.62"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.62"
					y1="170.99"
					x2="862.62"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.62"
					y1="165.86"
					x2="866.82"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.82"
					y1="165.86"
					x2="866.82"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="818.42 165.86 822.61 165.86 822.61 170.99 818.42 170.99 818.42 165.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="818.42"
					y1="165.86"
					x2="822.61"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.61"
					y1="165.86"
					x2="822.61"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="822.61"
					y1="170.99"
					x2="818.42"
					y2="170.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.42"
					y1="170.99"
					x2="818.42"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.62"
					y1="166.79"
					x2="822.61"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="868.69 170.52 866.82 170.52 866.82 165.86 864.48 165.86 864.48 165.39 868.69 165.39 868.69 170.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="868.69"
					y1="170.52"
					x2="866.82"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.82"
					y1="170.52"
					x2="866.82"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="866.82"
					y1="165.86"
					x2="864.48"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.48"
					y1="165.86"
					x2="864.48"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="864.48"
					y1="165.39"
					x2="868.69"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.69"
					y1="165.39"
					x2="868.69"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="816.55 165.39 820.75 165.39 820.75 165.86 818.42 165.86 818.42 170.52 816.55 170.52 816.55 165.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="816.55"
					y1="165.39"
					x2="820.75"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.75"
					y1="165.39"
					x2="820.75"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.75"
					y1="165.86"
					x2="818.42"
					y2="165.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.42"
					y1="165.86"
					x2="818.42"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.42"
					y1="170.52"
					x2="816.55"
					y2="170.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.55"
					y1="170.52"
					x2="816.55"
					y2="165.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="814.18 166.79 814.18 169.16 720.05 169.16 720.05 166.79 814.18 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="814.18"
					y1="166.79"
					x2="814.18"
					y2="169.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.18"
					y1="169.16"
					x2="720.05"
					y2="169.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.05"
					y1="169.16"
					x2="720.05"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.05"
					y1="166.79"
					x2="814.18"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="868.69 166.79 873.42 166.79 873.42 181.01 868.69 181.01 868.69 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="873.42"
					y1="166.79"
					x2="868.69"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.42"
					y1="181.01"
					x2="873.42"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.69"
					y1="181.01"
					x2="873.42"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.69"
					y1="166.79"
					x2="868.69"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="811.81 166.79 816.55 166.79 816.55 181.01 811.81 181.01 811.81 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="816.55"
					y1="166.79"
					x2="811.81"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="816.55"
					y1="181.01"
					x2="816.55"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.81"
					y1="181.01"
					x2="816.55"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.81"
					y1="166.79"
					x2="811.81"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="717.68 166.79 722.42 166.79 722.42 181.01 717.68 181.01 717.68 166.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="722.42"
					y1="166.79"
					x2="717.68"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.42"
					y1="181.01"
					x2="722.42"
					y2="166.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.68"
					y1="181.01"
					x2="722.42"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.68"
					y1="166.79"
					x2="717.68"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="901.2"
					y1="670.28"
					x2="920.16"
					y2="670.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="920.16"
					y1="670.28"
					x2="922.05"
					y2="670.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="836.77"
					x2="748.38"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="817.81"
					x2="748.38"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="817.81"
					x2="744.82"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="836.77"
					x2="651.18"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="817.81"
					x2="651.18"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="817.81"
					x2="654.73"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="817.81"
					x2="744.82"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="655.92 837.95 655.92 836.77 651.18 836.77 651.18 837.95 655.92 837.95"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="743.63 836.77 743.63 837.95 748.38 837.95 748.38 836.77 743.63 836.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="655.92 817.81 655.92 816.62 651.18 816.62 651.18 817.81 655.92 817.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="743.63 816.62 743.63 817.81 748.38 817.81 748.38 816.62 743.63 816.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="655.92"
					y1="837.95"
					x2="651.18"
					y2="837.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.18"
					y1="837.95"
					x2="651.18"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.18"
					y1="836.77"
					x2="655.92"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.92"
					y1="836.77"
					x2="655.92"
					y2="837.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.63"
					y1="836.77"
					x2="748.38"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="836.77"
					x2="748.38"
					y2="837.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="837.95"
					x2="743.63"
					y2="837.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.63"
					y1="837.95"
					x2="743.63"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.92"
					y1="817.81"
					x2="651.18"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.18"
					y1="817.81"
					x2="651.18"
					y2="816.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.18"
					y1="816.62"
					x2="655.92"
					y2="816.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.92"
					y1="816.62"
					x2="655.92"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.63"
					y1="816.62"
					x2="748.38"
					y2="816.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="816.62"
					x2="748.38"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="748.38"
					y1="817.81"
					x2="743.63"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.63"
					y1="817.81"
					x2="743.63"
					y2="816.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="657.11 836.77 657.11 817.81 655.32 817.81 655.32 836.77 657.11 836.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="744.23 836.77 744.23 817.81 742.45 817.81 742.45 836.77 744.23 836.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="682.1 757.46 679.17 760.39 739.51 820.74 742.45 817.81 682.1 757.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="655.32"
					y1="817.81"
					x2="654.73"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.32"
					y1="836.77"
					x2="654.73"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.73"
					y1="817.81"
					x2="654.73"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.23"
					y1="817.81"
					x2="744.82"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.23"
					y1="836.77"
					x2="744.82"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.82"
					y1="817.81"
					x2="744.82"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.11"
					y1="836.77"
					x2="657.11"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="657.11"
					y1="817.81"
					x2="655.32"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.32"
					y1="817.81"
					x2="655.32"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.32"
					y1="836.77"
					x2="657.11"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.23"
					y1="836.77"
					x2="744.23"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="744.23"
					y1="817.81"
					x2="742.45"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.45"
					y1="817.81"
					x2="742.45"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.45"
					y1="836.77"
					x2="744.23"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="682.1"
					y1="757.46"
					x2="679.17"
					y2="760.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="679.17"
					y1="760.39"
					x2="739.51"
					y2="820.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.51"
					y1="820.74"
					x2="742.45"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.45"
					y1="817.81"
					x2="682.1"
					y2="757.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="654.73"
					y1="817.81"
					x2="654.73"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="817.81"
					x2="654.73"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="817.81"
					x2="651.18"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="817.81"
					x2="651.18"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="836.77"
					x2="651.18"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="654.73"
					y1="836.77"
					x2="651.18"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="817.81"
					x2="744.82"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="817.81"
					x2="744.82"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="817.81"
					x2="748.38"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="817.81"
					x2="748.38"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="836.77"
					x2="748.38"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="744.82"
					y1="836.77"
					x2="748.38"
					y2="836.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="530.85"
					y1="715.5"
					x2="511.89"
					y2="715.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="511.89"
					y1="715.5"
					x2="426.16"
					y2="715.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="162.23"
					y1="162.05"
					x2="162.23"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="452.45"
					x2="589.08"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="452.45"
					x2="600.94"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="452.45"
					x2="589.08"
					y2="452.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="376.59"
					x2="589.08"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="376.59"
					x2="600.94"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="376.59"
					x2="589.08"
					y2="376.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="482.18"
					x2="600.94"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="482.18"
					x2="589.08"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="482.18"
					x2="600.94"
					y2="482.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="543.82"
					x2="600.94"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="543.82"
					x2="589.08"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="543.82"
					x2="600.94"
					y2="543.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="550.54"
					x2="600.94"
					y2="543.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="587.9 377.77 589.08 377.77 589.08 373.03 587.9 373.03 587.9 377.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="589.08 451.26 587.9 451.26 587.9 456 589.08 456 589.08 451.26"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="600.94 377.77 602.12 377.77 602.12 373.03 600.94 373.03 600.94 377.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="602.12 451.26 600.94 451.26 600.94 456 602.12 456 602.12 451.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="587.9"
					y1="377.77"
					x2="587.9"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.9"
					y1="373.03"
					x2="589.08"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="373.03"
					x2="589.08"
					y2="377.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="377.77"
					x2="587.9"
					y2="377.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="451.26"
					x2="589.08"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="456"
					x2="587.9"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.9"
					y1="456"
					x2="587.9"
					y2="451.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.9"
					y1="451.26"
					x2="589.08"
					y2="451.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="377.77"
					x2="600.94"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="373.03"
					x2="602.12"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.12"
					y1="373.03"
					x2="602.12"
					y2="377.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.12"
					y1="377.77"
					x2="600.94"
					y2="377.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.12"
					y1="451.26"
					x2="602.12"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.12"
					y1="456"
					x2="600.94"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="456"
					x2="600.94"
					y2="451.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="451.26"
					x2="602.12"
					y2="451.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="589.08 378.96 600.94 378.96 600.94 377.18 589.08 377.18 589.08 378.96"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="589.08 451.86 600.94 451.86 600.94 450.08 589.08 450.08 589.08 451.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="651.23 399.79 648.29 396.86 598 447.14 600.94 450.08 651.23 399.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="600.94"
					y1="377.18"
					x2="600.94"
					y2="376.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="377.18"
					x2="589.08"
					y2="376.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="376.59"
					x2="589.08"
					y2="376.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="451.86"
					x2="600.94"
					y2="452.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="451.86"
					x2="589.08"
					y2="452.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="452.45"
					x2="589.08"
					y2="452.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="378.96"
					x2="600.94"
					y2="378.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="378.96"
					x2="600.94"
					y2="377.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="377.18"
					x2="589.08"
					y2="377.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="377.18"
					x2="589.08"
					y2="378.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="451.86"
					x2="600.94"
					y2="451.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="451.86"
					x2="600.94"
					y2="450.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="450.08"
					x2="589.08"
					y2="450.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="450.08"
					x2="589.08"
					y2="451.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="651.23"
					y1="399.79"
					x2="648.29"
					y2="396.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="648.29"
					y1="396.86"
					x2="598"
					y2="447.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598"
					y1="447.14"
					x2="600.94"
					y2="450.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="450.08"
					x2="651.23"
					y2="399.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="376.59"
					x2="589.08"
					y2="376.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="376.59"
					x2="589.08"
					y2="376.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="376.59"
					x2="600.94"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="376.59"
					x2="600.94"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="376.59"
					x2="589.08"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="376.59"
					x2="589.08"
					y2="373.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="452.45"
					x2="589.08"
					y2="452.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="452.45"
					x2="589.08"
					y2="452.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="452.45"
					x2="600.94"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="452.45"
					x2="600.94"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="452.45"
					x2="589.08"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="452.45"
					x2="589.08"
					y2="456"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="602.12 542.63 600.94 542.63 600.94 547.38 602.12 547.38 602.12 542.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="600.94 483.37 602.12 483.37 602.12 478.63 600.94 478.63 600.94 483.37"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="589.08 542.63 587.9 542.63 587.9 547.38 589.08 547.38 589.08 542.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="587.9 483.37 589.08 483.37 589.08 478.63 587.9 478.63 587.9 483.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="602.12"
					y1="542.63"
					x2="602.12"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.12"
					y1="547.38"
					x2="600.94"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="547.38"
					x2="600.94"
					y2="542.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="542.63"
					x2="602.12"
					y2="542.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="483.37"
					x2="600.94"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="478.63"
					x2="602.12"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.12"
					y1="478.63"
					x2="602.12"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="602.12"
					y1="483.37"
					x2="600.94"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="542.63"
					x2="589.08"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="547.38"
					x2="587.9"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.9"
					y1="547.38"
					x2="587.9"
					y2="542.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.9"
					y1="542.63"
					x2="589.08"
					y2="542.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.9"
					y1="483.37"
					x2="587.9"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="587.9"
					y1="478.63"
					x2="589.08"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="478.63"
					x2="589.08"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="483.37"
					x2="587.9"
					y2="483.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="600.94 541.45 589.08 541.45 589.08 543.23 600.94 543.23 600.94 541.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="600.94 482.78 589.08 482.78 589.08 484.55 600.94 484.55 600.94 482.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="548.85 524.78 551.78 527.72 592.02 487.49 589.08 484.55 548.85 524.78"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="589.08"
					y1="543.23"
					x2="589.08"
					y2="543.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="543.23"
					x2="600.94"
					y2="543.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="543.82"
					x2="600.94"
					y2="543.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="482.78"
					x2="589.08"
					y2="482.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="482.78"
					x2="600.94"
					y2="482.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="482.18"
					x2="600.94"
					y2="482.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="541.45"
					x2="589.08"
					y2="541.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="541.45"
					x2="589.08"
					y2="543.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="543.23"
					x2="600.94"
					y2="543.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="543.23"
					x2="600.94"
					y2="541.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="482.78"
					x2="589.08"
					y2="482.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="482.78"
					x2="589.08"
					y2="484.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="484.55"
					x2="600.94"
					y2="484.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.94"
					y1="484.55"
					x2="600.94"
					y2="482.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.85"
					y1="524.78"
					x2="551.78"
					y2="527.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.78"
					y1="527.72"
					x2="592.02"
					y2="487.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="592.02"
					y1="487.49"
					x2="589.08"
					y2="484.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="484.55"
					x2="548.85"
					y2="524.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.08"
					y1="543.82"
					x2="600.94"
					y2="543.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="543.82"
					x2="600.94"
					y2="543.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="543.82"
					x2="589.08"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="543.82"
					x2="589.08"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="543.82"
					x2="600.94"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="543.82"
					x2="600.94"
					y2="547.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="482.18"
					x2="600.94"
					y2="482.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="482.18"
					x2="600.94"
					y2="482.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="482.18"
					x2="589.08"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="482.18"
					x2="589.08"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="482.18"
					x2="600.94"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="600.94"
					y1="482.18"
					x2="600.94"
					y2="478.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="674.87"
					y1="475.62"
					x2="674.87"
					y2="550.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="522.47"
					x2="895.41"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="520.1"
					x2="892.44"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="510.62"
					x2="895.41"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="510.62"
					x2="892.44"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="522.47"
					x2="722.35"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="520.1"
					x2="725.31"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="510.62"
					x2="722.35"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="510.62"
					x2="725.31"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="727.09 520.1 725.9 520.1 725.9 522.47 727.09 522.47 727.09 520.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="727.09 523.65 727.09 522.47 722.35 522.47 722.35 523.65 727.09 523.65"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="891.85 520.1 890.66 520.1 890.66 522.47 891.85 522.47 891.85 520.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="890.66 522.47 890.66 523.65 895.41 523.65 895.41 522.47 890.66 522.47"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="727.09 510.62 727.09 507.65 722.35 507.65 722.35 510.62 727.09 510.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="890.66 507.65 890.66 510.62 895.41 510.62 895.41 507.65 890.66 507.65"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="727.09"
					y1="520.1"
					x2="727.09"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.09"
					y1="522.47"
					x2="725.9"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.9"
					y1="522.47"
					x2="725.9"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.9"
					y1="520.1"
					x2="727.09"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.09"
					y1="523.65"
					x2="722.35"
					y2="523.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.35"
					y1="523.65"
					x2="722.35"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.35"
					y1="522.47"
					x2="727.09"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.09"
					y1="522.47"
					x2="727.09"
					y2="523.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.85"
					y1="520.1"
					x2="891.85"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.85"
					y1="522.47"
					x2="890.66"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.66"
					y1="522.47"
					x2="890.66"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.66"
					y1="520.1"
					x2="891.85"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.66"
					y1="522.47"
					x2="895.41"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.41"
					y1="522.47"
					x2="895.41"
					y2="523.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.41"
					y1="523.65"
					x2="890.66"
					y2="523.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.66"
					y1="523.65"
					x2="890.66"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.09"
					y1="510.62"
					x2="722.35"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.35"
					y1="510.62"
					x2="722.35"
					y2="507.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="722.35"
					y1="507.65"
					x2="727.09"
					y2="507.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="727.09"
					y1="507.65"
					x2="727.09"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.66"
					y1="507.65"
					x2="895.41"
					y2="507.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.41"
					y1="507.65"
					x2="895.41"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="895.41"
					y1="510.62"
					x2="890.66"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="890.66"
					y1="510.62"
					x2="890.66"
					y2="507.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="730.64 520.1 730.64 510.62 725.9 510.62 725.9 520.1 730.64 520.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="891.85 520.1 891.85 510.62 887.11 510.62 887.11 520.1 891.85 520.1"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="806.51 510.62 806.51 514.77 887.11 514.77 887.11 510.62 806.51 510.62"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="759.09 514.77 759.09 518.91 839.7 518.91 839.7 514.77 759.09 514.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="725.9"
					y1="510.62"
					x2="725.31"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.9"
					y1="520.1"
					x2="725.31"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.31"
					y1="510.62"
					x2="725.31"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.85"
					y1="510.62"
					x2="892.44"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.85"
					y1="520.1"
					x2="892.44"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.44"
					y1="510.62"
					x2="892.44"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.64"
					y1="520.1"
					x2="730.64"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="730.64"
					y1="510.62"
					x2="725.9"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.9"
					y1="510.62"
					x2="725.9"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.9"
					y1="520.1"
					x2="730.64"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.85"
					y1="520.1"
					x2="891.85"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.85"
					y1="510.62"
					x2="887.11"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.11"
					y1="510.62"
					x2="887.11"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.11"
					y1="520.1"
					x2="891.85"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="510.62"
					x2="806.51"
					y2="514.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.51"
					y1="514.77"
					x2="887.11"
					y2="514.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.11"
					y1="514.77"
					x2="887.11"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.11"
					y1="510.62"
					x2="806.51"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.09"
					y1="514.77"
					x2="759.09"
					y2="518.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.09"
					y1="518.91"
					x2="839.7"
					y2="518.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.7"
					y1="518.91"
					x2="839.7"
					y2="514.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="839.7"
					y1="514.77"
					x2="759.09"
					y2="514.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="725.31"
					y1="510.62"
					x2="725.31"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="510.62"
					x2="725.31"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="520.1"
					x2="725.31"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="510.62"
					x2="722.35"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="520.1"
					x2="725.31"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="522.47"
					x2="722.35"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="725.31"
					y1="522.47"
					x2="722.35"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="510.62"
					x2="892.44"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="510.62"
					x2="892.44"
					y2="520.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="520.1"
					x2="892.44"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="510.62"
					x2="895.41"
					y2="510.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="520.1"
					x2="892.44"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="522.47"
					x2="895.41"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="892.44"
					y1="522.47"
					x2="895.41"
					y2="522.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="674.87"
					y1="550.54"
					x2="600.94"
					y2="550.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="802.26"
					x2="752.55"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="802.26"
					x2="764.4"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="802.26"
					x2="752.55"
					y2="802.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="726.4"
					x2="752.55"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="726.4"
					x2="764.4"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="726.4"
					x2="752.55"
					y2="726.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="817.81"
					x2="764.4"
					y2="802.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="802.26"
					x2="752.55"
					y2="817.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="751.36 727.58 752.55 727.58 752.55 722.84 751.36 722.84 751.36 727.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="752.55 801.08 751.36 801.08 751.36 805.82 752.55 805.82 752.55 801.08"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="764.4 727.58 765.59 727.58 765.59 722.84 764.4 722.84 764.4 727.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="765.59 801.08 764.4 801.08 764.4 805.82 765.59 805.82 765.59 801.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="751.36"
					y1="727.58"
					x2="751.36"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.36"
					y1="722.84"
					x2="752.55"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="722.84"
					x2="752.55"
					y2="727.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="727.58"
					x2="751.36"
					y2="727.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="801.08"
					x2="752.55"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="805.82"
					x2="751.36"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.36"
					y1="805.82"
					x2="751.36"
					y2="801.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="751.36"
					y1="801.08"
					x2="752.55"
					y2="801.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="727.58"
					x2="764.4"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="722.84"
					x2="765.59"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.59"
					y1="722.84"
					x2="765.59"
					y2="727.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.59"
					y1="727.58"
					x2="764.4"
					y2="727.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.59"
					y1="801.08"
					x2="765.59"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.59"
					y1="805.82"
					x2="764.4"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="805.82"
					x2="764.4"
					y2="801.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="801.08"
					x2="765.59"
					y2="801.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="752.55 728.77 764.4 728.77 764.4 726.99 752.55 726.99 752.55 728.77"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="752.55 801.67 764.4 801.67 764.4 799.89 752.55 799.89 752.55 801.67"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="814.69 749.6 811.76 746.67 761.47 796.96 764.4 799.89 814.69 749.6"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="764.4"
					y1="726.99"
					x2="764.4"
					y2="726.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="726.99"
					x2="752.55"
					y2="726.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="726.4"
					x2="752.55"
					y2="726.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="801.67"
					x2="764.4"
					y2="802.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="801.67"
					x2="752.55"
					y2="802.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="802.26"
					x2="752.55"
					y2="802.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="728.77"
					x2="764.4"
					y2="728.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="728.77"
					x2="764.4"
					y2="726.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="726.99"
					x2="752.55"
					y2="726.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="726.99"
					x2="752.55"
					y2="728.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="801.67"
					x2="764.4"
					y2="801.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="801.67"
					x2="764.4"
					y2="799.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="799.89"
					x2="752.55"
					y2="799.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="752.55"
					y1="799.89"
					x2="752.55"
					y2="801.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="814.69"
					y1="749.6"
					x2="811.76"
					y2="746.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.76"
					y1="746.67"
					x2="761.47"
					y2="796.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.47"
					y1="796.96"
					x2="764.4"
					y2="799.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="799.89"
					x2="814.69"
					y2="749.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="726.4"
					x2="752.55"
					y2="726.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="726.4"
					x2="752.55"
					y2="726.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="726.4"
					x2="764.4"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="726.4"
					x2="764.4"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="726.4"
					x2="752.55"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="726.4"
					x2="752.55"
					y2="722.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="802.26"
					x2="752.55"
					y2="802.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="802.26"
					x2="752.55"
					y2="802.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="802.26"
					x2="764.4"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="764.4"
					y1="802.26"
					x2="764.4"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="802.26"
					x2="752.55"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="752.55"
					y1="802.26"
					x2="752.55"
					y2="805.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="426.16"
					y1="715.5"
					x2="426.16"
					y2="694.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="426.16"
					y1="694.4"
					x2="414.31"
					y2="694.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="492.24"
					x2="81.52"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="489.87"
					x2="84.48"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="480.39"
					x2="81.52"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="480.39"
					x2="84.48"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="492.24"
					x2="202.42"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="489.87"
					x2="199.46"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="480.39"
					x2="202.42"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="480.39"
					x2="199.46"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="480.39"
					x2="68.97"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="68.97"
					y1="492.24"
					x2="84.48"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="492.24"
					x2="204.21"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="197.68 489.87 197.68 492.24 198.86 492.24 198.86 489.87 197.68 489.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="197.68 493.43 202.42 493.43 202.42 492.24 197.68 492.24 197.68 493.43"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="85.07 489.87 85.07 492.24 86.26 492.24 86.26 489.87 85.07 489.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="86.26 492.24 81.52 492.24 81.52 493.43 86.26 493.43 86.26 492.24"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="197.68 480.39 202.42 480.39 202.42 477.43 197.68 477.43 197.68 480.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="86.26 477.43 81.52 477.43 81.52 480.39 86.26 480.39 86.26 477.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="197.68"
					y1="489.87"
					x2="197.68"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.68"
					y1="492.24"
					x2="198.86"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.86"
					y1="492.24"
					x2="198.86"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.86"
					y1="489.87"
					x2="197.68"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.68"
					y1="493.43"
					x2="202.42"
					y2="493.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.42"
					y1="493.43"
					x2="202.42"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.42"
					y1="492.24"
					x2="197.68"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.68"
					y1="492.24"
					x2="197.68"
					y2="493.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="489.87"
					x2="85.07"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="492.24"
					x2="86.26"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.26"
					y1="492.24"
					x2="86.26"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.26"
					y1="489.87"
					x2="85.07"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.26"
					y1="492.24"
					x2="81.52"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="81.52"
					y1="492.24"
					x2="81.52"
					y2="493.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="81.52"
					y1="493.43"
					x2="86.26"
					y2="493.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.26"
					y1="493.43"
					x2="86.26"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.68"
					y1="480.39"
					x2="202.42"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.42"
					y1="480.39"
					x2="202.42"
					y2="477.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="202.42"
					y1="477.43"
					x2="197.68"
					y2="477.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.68"
					y1="477.43"
					x2="197.68"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.26"
					y1="477.43"
					x2="81.52"
					y2="477.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="81.52"
					y1="477.43"
					x2="81.52"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="81.52"
					y1="480.39"
					x2="86.26"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="86.26"
					y1="480.39"
					x2="86.26"
					y2="477.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="194.12 489.87 198.86 489.87 198.86 480.39 194.12 480.39 194.12 489.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="85.07 489.87 89.81 489.87 89.81 480.39 85.07 480.39 85.07 489.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="144.34 480.39 89.81 480.39 89.81 484.54 144.34 484.54 144.34 480.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="165.67 484.54 111.15 484.54 111.15 488.68 165.67 488.68 165.67 484.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="198.86"
					y1="480.39"
					x2="199.46"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.86"
					y1="489.87"
					x2="199.46"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.46"
					y1="480.39"
					x2="199.46"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="480.39"
					x2="84.48"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="489.87"
					x2="84.48"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="84.48"
					y1="480.39"
					x2="84.48"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.12"
					y1="489.87"
					x2="194.12"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.12"
					y1="480.39"
					x2="198.86"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.86"
					y1="480.39"
					x2="198.86"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.86"
					y1="489.87"
					x2="194.12"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="489.87"
					x2="85.07"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="85.07"
					y1="480.39"
					x2="89.81"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.81"
					y1="480.39"
					x2="89.81"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.81"
					y1="489.87"
					x2="85.07"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.34"
					y1="480.39"
					x2="144.34"
					y2="484.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="144.34"
					y1="484.54"
					x2="89.81"
					y2="484.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.81"
					y1="484.54"
					x2="89.81"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="89.81"
					y1="480.39"
					x2="144.34"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.67"
					y1="484.54"
					x2="165.67"
					y2="488.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.67"
					y1="488.68"
					x2="111.15"
					y2="488.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.15"
					y1="488.68"
					x2="111.15"
					y2="484.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="111.15"
					y1="484.54"
					x2="165.67"
					y2="484.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.46"
					y1="480.39"
					x2="199.46"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="480.39"
					x2="199.46"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="489.87"
					x2="199.46"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="480.39"
					x2="202.42"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="489.87"
					x2="199.46"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="492.24"
					x2="202.42"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="199.46"
					y1="492.24"
					x2="202.42"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="480.39"
					x2="84.48"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="480.39"
					x2="84.48"
					y2="489.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="489.87"
					x2="84.48"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="480.39"
					x2="81.52"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="489.87"
					x2="84.48"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="492.24"
					x2="81.52"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="84.48"
					y1="492.24"
					x2="81.52"
					y2="492.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="873.42"
					y1="162.05"
					x2="873.42"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="717.68"
					y1="181.01"
					x2="717.68"
					y2="162.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="589.08"
					y1="162.05"
					x2="589.08"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="446.62"
					y1="181.01"
					x2="446.62"
					y2="162.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<line
					x1="319.83"
					y1="162.05"
					x2="319.83"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".31"
				/>
				<polyline
					points="300.22 486.51 246.12 486.51 246.12 539.67 300.22 539.67 300.22 486.51"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="300.22"
					y1="539.67"
					x2="300.22"
					y2="537.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="534.14"
					x2="300.22"
					y2="528.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="525.04"
					x2="300.22"
					y2="519.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="515.94"
					x2="300.22"
					y2="510.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="506.83"
					x2="300.22"
					y2="501.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="497.73"
					x2="300.22"
					y2="492.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="488.63"
					x2="300.22"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="539.67"
					x2="248.71"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="252.12"
					y1="539.67"
					x2="257.81"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="261.22"
					y1="539.67"
					x2="266.91"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="270.33"
					y1="539.67"
					x2="276.02"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="279.43"
					y1="539.67"
					x2="285.12"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="288.53"
					y1="539.67"
					x2="294.22"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.64"
					y1="539.67"
					x2="300.22"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="486.51"
					x2="246.12"
					y2="488.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="492.04"
					x2="246.12"
					y2="497.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="501.15"
					x2="246.12"
					y2="506.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="510.25"
					x2="246.12"
					y2="515.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="519.35"
					x2="246.12"
					y2="525.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="528.46"
					x2="246.12"
					y2="534.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="537.56"
					x2="246.12"
					y2="539.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="486.51"
					x2="297.64"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.22"
					y1="486.51"
					x2="288.53"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.12"
					y1="486.51"
					x2="279.43"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.02"
					y1="486.51"
					x2="270.33"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="266.91"
					y1="486.51"
					x2="261.22"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.81"
					y1="486.51"
					x2="252.12"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.71"
					y1="486.51"
					x2="246.12"
					y2="486.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="303.02 539.47 304.65 539.47 304.65 486.71 303.02 486.71 303.02 494.99 304.36 494.99 304.36 531.2 303.02 531.2 303.02 539.47"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="303.02"
					y1="531.2"
					x2="303.02"
					y2="539.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="304.36"
					y1="531.2"
					x2="303.02"
					y2="531.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="304.36"
					y1="494.99"
					x2="304.36"
					y2="531.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="303.02"
					y1="494.99"
					x2="304.36"
					y2="494.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="303.02"
					y1="486.71"
					x2="303.02"
					y2="494.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="304.65"
					y1="486.71"
					x2="303.02"
					y2="486.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="304.65"
					y1="539.47"
					x2="304.65"
					y2="486.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="303.02"
					y1="539.47"
					x2="304.65"
					y2="539.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<polyline
					points="303.02 541.54 303.02 484.65 300.22 484.65 300.22 541.54 303.02 541.54"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="300.22"
					y1="541.54"
					x2="303.02"
					y2="541.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="300.22"
					y1="484.65"
					x2="300.22"
					y2="541.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="303.02"
					y1="484.65"
					x2="300.22"
					y2="484.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="303.02"
					y1="541.54"
					x2="303.02"
					y2="484.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".22"
				/>
				<line
					x1="303.02"
					y1="486.71"
					x2="304.65"
					y2="486.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.65"
					y1="486.71"
					x2="304.65"
					y2="539.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.65"
					y1="539.47"
					x2="303.02"
					y2="539.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.02"
					y1="484.65"
					x2="303.02"
					y2="541.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.02"
					y1="531.2"
					x2="304.36"
					y2="531.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.36"
					y1="531.2"
					x2="304.36"
					y2="494.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="304.36"
					y1="494.99"
					x2="303.02"
					y2="494.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="484.65"
					x2="303.02"
					y2="484.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.02"
					y1="541.54"
					x2="300.22"
					y2="541.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="300.22"
					y1="541.54"
					x2="300.22"
					y2="484.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="504.98 629.2 426.16 629.2 426.16 715.5 504.98 715.5 504.98 629.2"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="504.98"
					y1="715.5"
					x2="504.98"
					y2="629.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="715.5"
					x2="504.98"
					y2="715.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="629.2"
					x2="426.16"
					y2="715.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.98"
					y1="629.2"
					x2="426.16"
					y2="629.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.98"
					y1="635.12"
					x2="426.16"
					y2="635.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="403.18 632.76 332.06 632.76 332.06 694.4 403.18 694.4 403.18 632.76"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="403.18"
					y1="632.76"
					x2="332.06"
					y2="632.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.18"
					y1="694.4"
					x2="332.06"
					y2="694.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.18"
					y1="692.53"
					x2="332.06"
					y2="692.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.18"
					y1="632.76"
					x2="403.18"
					y2="694.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.06"
					y1="632.76"
					x2="332.06"
					y2="694.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.51"
					y1="635.56"
					x2="336.72"
					y2="635.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.72"
					y1="635.56"
					x2="334.86"
					y2="637.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.86"
					y1="637.43"
					x2="334.86"
					y2="689.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="334.86"
					y1="689.73"
					x2="336.72"
					y2="691.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="336.72"
					y1="691.6"
					x2="398.51"
					y2="691.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.51"
					y1="691.6"
					x2="400.38"
					y2="689.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.38"
					y1="689.73"
					x2="400.38"
					y2="637.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="400.38"
					y1="637.43"
					x2="398.51"
					y2="635.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m394.73,648.17c0-5.15-4.18-9.33-9.34-9.33s-9.33,4.18-9.33,9.33,4.18,9.33,9.33,9.33,9.34-4.18,9.34-9.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m392.4,678.99c0-3.86-3.13-7-7-7s-7,3.14-7,7,3.14,7,7,7,7-3.13,7-7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m356.84,648.17c0-3.87-3.13-7-7-7s-7,3.13-7,7,3.14,7,7,7,7-3.14,7-7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m359.17,678.99c0-5.15-4.18-9.33-9.33-9.33s-9.33,4.18-9.33,9.33,4.18,9.34,9.33,9.34,9.33-4.18,9.33-9.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="297.81 596.42 297.81 550.07 297.56 549.13 296.88 548.45 295.94 548.2 247.99 548.2 247.06 548.45 246.37 549.13 246.12 550.07 246.12 596.42 246.37 597.35 247.06 598.04 247.99 598.28 295.94 598.28 296.88 598.04 297.56 597.35 297.81 596.42"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m297.81,596.42c0,1.03-.84,1.86-1.87,1.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.99"
					y1="598.28"
					x2="295.94"
					y2="598.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m247.99,598.28c-1.03,0-1.87-.83-1.87-1.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="246.12"
					y1="550.07"
					x2="246.12"
					y2="596.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m246.12,550.07c0-1.03.84-1.86,1.87-1.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="295.94"
					y1="548.2"
					x2="247.99"
					y2="548.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m295.94,548.2c1.03,0,1.87.83,1.87,1.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="297.81"
					y1="596.42"
					x2="297.81"
					y2="550.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.14"
					y1="591.75"
					x2="293.14"
					y2="554.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.28"
					y1="552.87"
					x2="257.32"
					y2="552.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.46"
					y1="554.74"
					x2="255.46"
					y2="591.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.32"
					y1="593.62"
					x2="291.28"
					y2="593.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.14"
					y1="591.75"
					x2="293.14"
					y2="591.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m291.28,552.87c1.03,0,1.87.84,1.87,1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m255.46,554.74c0-1.03.84-1.87,1.87-1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m257.32,593.62c-1.03,0-1.87-.84-1.87-1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m293.14,591.75c0,1.03-.84,1.87-1.87,1.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m267.59,573.24c0-1.54-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8,1.25,2.8,2.8,2.8,2.8-1.25,2.8-2.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="267.39 574.08 267.99 573.84 268.23 573.24 267.98 572.65 267.39 572.41 248.92 572.41 248.33 572.65 248.08 573.24 248.33 573.84 248.92 574.08 267.39 574.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="248.92"
					y1="574.08"
					x2="267.39"
					y2="574.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m248.92,574.08c-.46,0-.84-.38-.84-.84s.38-.84.84-.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.39"
					y1="572.41"
					x2="248.92"
					y2="572.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m267.39,572.41h0c.46,0,.84.38.84.84s-.37.84-.84.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="253.68 575.11 253.68 574.08 248.92 574.08 248.33 573.84 248.08 573.24 248.33 572.65 248.92 572.41 253.68 572.41 253.68 571.38 247.62 571.38 247.62 575.11 253.68 575.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="247.62"
					y1="575.11"
					x2="253.68"
					y2="575.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="247.62"
					y1="571.38"
					x2="247.62"
					y2="575.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.68"
					y1="571.38"
					x2="247.62"
					y2="571.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.68"
					y1="572.41"
					x2="253.68"
					y2="571.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.92"
					y1="572.41"
					x2="253.68"
					y2="572.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m248.92,574.08c-.46,0-.84-.38-.84-.84s.38-.84.84-.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.68"
					y1="574.08"
					x2="248.92"
					y2="574.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.68"
					y1="575.11"
					x2="253.68"
					y2="574.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="257.04 575.08 257.04 574.08 253.78 574.08 253.78 575.08 257.04 575.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="253.78"
					y1="575.08"
					x2="257.04"
					y2="575.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.78"
					y1="574.08"
					x2="253.78"
					y2="575.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.04"
					y1="574.08"
					x2="253.78"
					y2="574.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.04"
					y1="575.08"
					x2="257.04"
					y2="574.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="257.04 571.41 253.78 571.41 253.78 572.41 257.04 572.41 257.04 571.41"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="257.04"
					y1="572.41"
					x2="257.04"
					y2="571.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.78"
					y1="572.41"
					x2="257.04"
					y2="572.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="253.78"
					y1="571.41"
					x2="253.78"
					y2="572.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="257.04"
					y1="571.41"
					x2="253.78"
					y2="571.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="859.79 767.01 857.9 771.24 857.24 775.83 857.9 780.42 859.79 784.65 862.18 787.43 865.19 789.55 872.25 792.24 878.1 793.18 884.03 792.83 889.73 791.19 894.95 791.32 900 792.65 904.61 795.08 906.61 796.36 910.74 797.86 915.11 797.64 916.84 796.96 921.45 796.96 921.45 795.03 919.35 795.03 921.29 791.82 922.05 788.14 922.05 763.52 921.3 759.88 919.29 756.76 916.28 754.58 912.69 753.65 912.12 753.65 909.16 754.14 904.5 756.64 899.94 759.06 894.95 760.37 889.79 760.5 884.07 758.84 878.13 758.48 872.25 759.43 865.19 762.11 862.18 764.23 859.79 767.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="900.15"
					y1="784.61"
					x2="900.15"
					y2="767.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.05"
					y1="763.52"
					x2="922.05"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.16"
					y1="763.52"
					x2="921.16"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.05"
					y1="788.14"
					x2="922.05"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.16"
					y1="788.14"
					x2="921.16"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.15"
					y1="767.51"
					x2="903.43"
					y2="767.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.43"
					y1="767.51"
					x2="903.43"
					y2="770.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.43"
					y1="770.22"
					x2="900.15"
					y2="770.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.15"
					y1="784.15"
					x2="903.43"
					y2="784.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.43"
					y1="784.15"
					x2="903.43"
					y2="781.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.43"
					y1="781.44"
					x2="900.15"
					y2="781.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.3"
					y1="795.03"
					x2="921.45"
					y2="795.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.3"
					y1="796.96"
					x2="921.45"
					y2="796.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.45"
					y1="796.96"
					x2="921.45"
					y2="795.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.3"
					y1="796.96"
					x2="913.3"
					y2="795.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.24"
					y1="775.83"
					x2="857.58"
					y2="772.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.58"
					y1="772.89"
					x2="858.34"
					y2="770.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.34"
					y1="770.04"
					x2="859.79"
					y2="767.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.79"
					y1="767.01"
					x2="862.18"
					y2="764.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.18"
					y1="764.23"
					x2="865.19"
					y2="762.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.19"
					y1="762.11"
					x2="868.61"
					y2="760.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.61"
					y1="760.56"
					x2="872.25"
					y2="759.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.25"
					y1="759.43"
					x2="875.16"
					y2="758.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.16"
					y1="758.78"
					x2="878.12"
					y2="758.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.12"
					y1="758.4"
					x2="881.08"
					y2="758.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.08"
					y1="758.35"
					x2="884.03"
					y2="758.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.03"
					y1="758.68"
					x2="888.6"
					y2="760.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.6"
					y1="760.01"
					x2="893.03"
					y2="762.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.03"
					y1="762.09"
					x2="896.99"
					y2="764.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.99"
					y1="764.55"
					x2="900.15"
					y2="767.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.79"
					y1="760.5"
					x2="893.9"
					y2="760.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.9"
					y1="760.48"
					x2="897.9"
					y2="759.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.9"
					y1="759.8"
					x2="900.05"
					y2="759.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.05"
					y1="759.1"
					x2="902.19"
					y2="758.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.19"
					y1="758.1"
					x2="905.29"
					y2="756.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.29"
					y1="756.12"
					x2="908.51"
					y2="754.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.51"
					y1="754.37"
					x2="911.64"
					y2="753.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.64"
					y1="753.67"
					x2="914.77"
					y2="753.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.77"
					y1="753.94"
					x2="917.62"
					y2="755.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.62"
					y1="755.16"
					x2="918.84"
					y2="756.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="918.84"
					y1="756.11"
					x2="919.9"
					y2="757.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.9"
					y1="757.31"
					x2="921.06"
					y2="759.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.06"
					y1="759.41"
					x2="921.71"
					y2="761.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.71"
					y1="761.42"
					x2="922.05"
					y2="763.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.16"
					y1="763.52"
					x2="921.07"
					y2="762.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.07"
					y1="762.58"
					x2="920.47"
					y2="760.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.47"
					y1="760.64"
					x2="919.02"
					y2="758.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.02"
					y1="758.93"
					x2="917.02"
					y2="757.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.02"
					y1="757.86"
					x2="914.37"
					y2="757.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.37"
					y1="757.35"
					x2="911.65"
					y2="757.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.65"
					y1="757.23"
					x2="910.3"
					y2="757.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.3"
					y1="757.25"
					x2="909.22"
					y2="757.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.22"
					y1="757.82"
					x2="908.91"
					y2="758.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.91"
					y1="758.49"
					x2="906.79"
					y2="765.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.79"
					y1="765.94"
					x2="906.16"
					y2="769.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.16"
					y1="769.64"
					x2="905.89"
					y2="773.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.89"
					y1="773.38"
					x2="905.89"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="889.73"
					y1="791.19"
					x2="893.85"
					y2="791.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.85"
					y1="791.22"
					x2="897.87"
					y2="791.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.87"
					y1="791.89"
					x2="900.04"
					y2="792.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.04"
					y1="792.58"
					x2="902.19"
					y2="793.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.19"
					y1="793.57"
					x2="905.3"
					y2="795.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.3"
					y1="795.54"
					x2="908.51"
					y2="797.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.51"
					y1="797.29"
					x2="910.6"
					y2="797.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.6"
					y1="797.87"
					x2="912.75"
					y2="798"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="912.75"
					y1="798"
					x2="914.87"
					y2="797.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.87"
					y1="797.7"
					x2="916.84"
					y2="796.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.16"
					y1="788.14"
					x2="921.07"
					y2="789.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.07"
					y1="789.09"
					x2="920.47"
					y2="791.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.47"
					y1="791.02"
					x2="919.02"
					y2="792.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.02"
					y1="792.73"
					x2="917.02"
					y2="793.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.02"
					y1="793.81"
					x2="914.37"
					y2="794.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.37"
					y1="794.31"
					x2="911.65"
					y2="794.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.65"
					y1="794.43"
					x2="910.3"
					y2="794.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.3"
					y1="794.41"
					x2="909.22"
					y2="793.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.22"
					y1="793.84"
					x2="908.91"
					y2="793.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="908.91"
					y1="793.18"
					x2="906.79"
					y2="785.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.79"
					y1="785.73"
					x2="906.16"
					y2="782.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.16"
					y1="782.03"
					x2="905.89"
					y2="778.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.89"
					y1="778.28"
					x2="905.89"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.24"
					y1="775.83"
					x2="857.58"
					y2="778.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.58"
					y1="778.77"
					x2="858.34"
					y2="781.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="858.34"
					y1="781.62"
					x2="859.79"
					y2="784.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.79"
					y1="784.65"
					x2="862.18"
					y2="787.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.18"
					y1="787.44"
					x2="865.19"
					y2="789.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.19"
					y1="789.55"
					x2="868.61"
					y2="791.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.61"
					y1="791.11"
					x2="872.25"
					y2="792.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="872.25"
					y1="792.24"
					x2="875.16"
					y2="792.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="875.16"
					y1="792.88"
					x2="878.12"
					y2="793.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="878.12"
					y1="793.26"
					x2="881.08"
					y2="793.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.08"
					y1="793.32"
					x2="884.03"
					y2="792.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.03"
					y1="792.98"
					x2="888.6"
					y2="791.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.6"
					y1="791.65"
					x2="893.03"
					y2="789.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.03"
					y1="789.57"
					x2="896.99"
					y2="787.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.99"
					y1="787.11"
					x2="900.15"
					y2="784.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.8"
					y1="755.2"
					x2="906.13"
					y2="755.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.13"
					y1="755.67"
					x2="905.13"
					y2="757.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.13"
					y1="757.02"
					x2="904.89"
					y2="758.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.89"
					y1="758.2"
					x2="904.25"
					y2="765.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.25"
					y1="765.76"
					x2="903.95"
					y2="773.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.95"
					y1="773.35"
					x2="903.95"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.8"
					y1="796.47"
					x2="906.13"
					y2="795.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.13"
					y1="795.99"
					x2="905.13"
					y2="794.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.13"
					y1="794.64"
					x2="904.89"
					y2="793.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.89"
					y1="793.46"
					x2="904.25"
					y2="785.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="904.25"
					y1="785.9"
					x2="903.95"
					y2="778.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.95"
					y1="778.32"
					x2="903.95"
					y2="775.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.35"
					y1="795.03"
					x2="919.9"
					y2="794.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.9"
					y1="794.35"
					x2="921.06"
					y2="792.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.06"
					y1="792.25"
					x2="921.71"
					y2="790.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.71"
					y1="790.24"
					x2="922.05"
					y2="788.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="877.91 670.28 877.91 733.85 922.05 733.85 922.05 670.28 877.91 670.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="877.91"
					y1="670.28"
					x2="877.91"
					y2="733.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.05"
					y1="670.28"
					x2="922.05"
					y2="733.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.91"
					y1="733.85"
					x2="922.05"
					y2="733.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="877.91"
					y1="670.28"
					x2="922.05"
					y2="670.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.18"
					y1="670.28"
					x2="920.18"
					y2="733.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.53"
					y1="678.36"
					x2="887.53"
					y2="725.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="887.53"
					y1="725.77"
					x2="915.98"
					y2="725.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.98"
					y1="725.77"
					x2="915.98"
					y2="678.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.98"
					y1="678.36"
					x2="887.53"
					y2="678.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.66"
					y1="676.49"
					x2="885.66"
					y2="727.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.66"
					y1="727.64"
					x2="917.85"
					y2="727.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.85"
					y1="727.64"
					x2="917.85"
					y2="676.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="917.85"
					y1="676.49"
					x2="885.66"
					y2="676.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m912.36,702.07c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8,1.25,2.8,2.8,2.8,2.8-1.26,2.8-2.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="920.37 699.73 916.45 700.11 915.57 700.41 910.63 701.03 909.97 701.38 909.71 702.07 909.97 702.76 910.63 703.1 915.57 703.72 916.45 704.03 920.37 704.4 921.74 703.95 922.59 702.79 922.59 701.34 921.74 700.18 920.37 699.73"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m920.37,699.73c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.33-2.34,2.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.45"
					y1="704.03"
					x2="920.37"
					y2="704.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m916.45,704.03c-.32-.03-.62-.13-.89-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.63"
					y1="703.1"
					x2="915.57"
					y2="703.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m910.63,703.1c-.52-.07-.92-.51-.92-1.04s.39-.97.92-1.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.57"
					y1="700.41"
					x2="910.63"
					y2="701.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m915.57,700.41c.27-.17.57-.28.89-.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="920.37"
					y1="699.73"
					x2="916.45"
					y2="700.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="918.04"
					y1="703.34"
					x2="916.65"
					y2="703.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.65"
					y1="700.8"
					x2="918.04"
					y2="700.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="918.04"
					y1="700.8"
					x2="918.04"
					y2="703.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m916.65,703.34c-.7,0-1.27-.57-1.27-1.27s.57-1.27,1.27-1.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m915.57,703.72c-.56-.36-.91-.98-.91-1.65s.34-1.29.91-1.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="922.05 747.38 921.1 747.38 921.1 752.13 922.05 752.13 922.05 747.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="922.05"
					y1="752.13"
					x2="922.05"
					y2="747.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.1"
					y1="752.13"
					x2="922.05"
					y2="752.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.1"
					y1="747.38"
					x2="921.1"
					y2="752.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.05"
					y1="747.38"
					x2="921.1"
					y2="747.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="922.05 804.28 922.05 799.54 921.1 799.54 921.1 804.28 922.05 804.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="921.1"
					y1="804.28"
					x2="922.05"
					y2="804.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.1"
					y1="799.54"
					x2="921.1"
					y2="804.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.05"
					y1="799.54"
					x2="921.1"
					y2="799.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="922.05"
					y1="804.28"
					x2="922.05"
					y2="799.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="921.1 749.28 913.38 749.28 913.38 750.23 921.1 750.23 921.1 749.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="921.1"
					y1="750.23"
					x2="921.1"
					y2="749.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.38"
					y1="750.23"
					x2="921.1"
					y2="750.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.38"
					y1="749.28"
					x2="913.38"
					y2="750.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.1"
					y1="749.28"
					x2="913.38"
					y2="749.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="921.1 802.38 921.1 801.44 913.38 801.44 913.38 802.38 921.1 802.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="913.38"
					y1="802.38"
					x2="921.1"
					y2="802.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.38"
					y1="801.44"
					x2="913.38"
					y2="802.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.1"
					y1="801.44"
					x2="913.38"
					y2="801.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.1"
					y1="802.38"
					x2="921.1"
					y2="801.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="915.75 750.23 913.86 750.23 913.86 801.44 915.75 801.44 915.75 750.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="915.75"
					y1="801.44"
					x2="915.75"
					y2="750.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.86"
					y1="801.44"
					x2="915.75"
					y2="801.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="913.86"
					y1="750.23"
					x2="913.86"
					y2="801.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="915.75"
					y1="750.23"
					x2="913.86"
					y2="750.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="670.28"
					x2="901.2"
					y2="670.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.4"
					y1="599.88"
					x2="764.4"
					y2="670.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="892.63 661.94 892.63 609.14 773.56 609.14 773.56 661.94 892.63 661.94"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="773.56"
					y1="661.94"
					x2="892.63"
					y2="661.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.56"
					y1="609.14"
					x2="773.56"
					y2="661.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.63"
					y1="609.14"
					x2="773.56"
					y2="609.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.63"
					y1="661.94"
					x2="892.63"
					y2="609.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="880.93 635.08 880.97 635.55 881.09 636.01 881.28 636.44 881.54 636.83 881.86 637.17 882.23 637.44 882.65 637.64 883.09 637.77 883.54 637.81 883.99 637.77 884.43 637.64 884.84 637.44 885.22 637.17 885.54 636.83 885.8 636.44 885.99 636.01 886.11 635.55 886.15 635.08 886.11 634.6 885.99 634.15 885.8 633.71 885.54 633.32 885.22 632.99 884.84 632.71 884.43 632.51 883.99 632.39 883.54 632.35 883.09 632.39 882.65 632.51 882.23 632.71 881.86 632.99 881.54 633.32 881.28 633.71 881.09 634.15 880.97 634.6 880.93 635.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="880.97"
					y1="634.6"
					x2="880.93"
					y2="635.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.09"
					y1="634.15"
					x2="880.97"
					y2="634.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.28"
					y1="633.71"
					x2="881.09"
					y2="634.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.54"
					y1="633.32"
					x2="881.28"
					y2="633.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.86"
					y1="632.99"
					x2="881.54"
					y2="633.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.23"
					y1="632.71"
					x2="881.86"
					y2="632.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.65"
					y1="632.51"
					x2="882.23"
					y2="632.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.09"
					y1="632.39"
					x2="882.65"
					y2="632.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.54"
					y1="632.35"
					x2="883.09"
					y2="632.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.99"
					y1="632.39"
					x2="883.54"
					y2="632.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.43"
					y1="632.51"
					x2="883.99"
					y2="632.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.84"
					y1="632.71"
					x2="884.43"
					y2="632.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.22"
					y1="632.99"
					x2="884.84"
					y2="632.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.54"
					y1="633.32"
					x2="885.22"
					y2="632.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.8"
					y1="633.71"
					x2="885.54"
					y2="633.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.99"
					y1="634.15"
					x2="885.8"
					y2="633.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.11"
					y1="634.6"
					x2="885.99"
					y2="634.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.15"
					y1="635.08"
					x2="886.11"
					y2="634.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.11"
					y1="635.55"
					x2="886.15"
					y2="635.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.99"
					y1="636.01"
					x2="886.11"
					y2="635.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.8"
					y1="636.44"
					x2="885.99"
					y2="636.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.54"
					y1="636.83"
					x2="885.8"
					y2="636.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="885.22"
					y1="637.17"
					x2="885.54"
					y2="636.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.84"
					y1="637.44"
					x2="885.22"
					y2="637.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.43"
					y1="637.64"
					x2="884.84"
					y2="637.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.99"
					y1="637.77"
					x2="884.43"
					y2="637.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.54"
					y1="637.81"
					x2="883.99"
					y2="637.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.09"
					y1="637.77"
					x2="883.54"
					y2="637.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.65"
					y1="637.64"
					x2="883.09"
					y2="637.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="882.23"
					y1="637.44"
					x2="882.65"
					y2="637.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.86"
					y1="637.17"
					x2="882.23"
					y2="637.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.54"
					y1="636.83"
					x2="881.86"
					y2="637.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.28"
					y1="636.44"
					x2="881.54"
					y2="636.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="881.09"
					y1="636.01"
					x2="881.28"
					y2="636.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="880.97"
					y1="635.55"
					x2="881.09"
					y2="636.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="880.93"
					y1="635.08"
					x2="880.97"
					y2="635.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="895.68 632.72 896.08 632.76 896.45 632.86 896.81 633.04 897.13 633.27 897.41 633.57 897.64 633.9 897.8 634.27 897.9 634.67 897.94 635.08 897.9 635.49 897.8 635.88 897.64 636.25 897.41 636.59 897.13 636.88 896.81 637.12 896.45 637.29 896.08 637.4 895.68 637.43 891.9 637.06 891.6 637 891.31 636.9 891.04 636.75 886.27 636.12 886.1 636.09 885.95 636.02 885.8 635.93 885.67 635.81 885.56 635.67 885.48 635.51 885.42 635.35 885.39 635.17 885.39 634.99 885.42 634.81 885.48 634.64 885.56 634.49 885.67 634.35 885.8 634.23 885.95 634.14 886.1 634.07 886.27 634.03 891.04 633.41 891.31 633.26 891.6 633.15 891.9 633.1 895.68 632.72"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="895.68"
					y1="632.72"
					x2="891.9"
					y2="633.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.04"
					y1="633.41"
					x2="886.27"
					y2="634.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="886.27"
					y1="636.12"
					x2="891.04"
					y2="636.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.9"
					y1="637.06"
					x2="895.68"
					y2="637.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.44"
					y1="636.36"
					x2="892.1"
					y2="636.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="892.1"
					y1="633.8"
					x2="893.44"
					y2="633.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="893.44"
					y1="633.8"
					x2="893.44"
					y2="636.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m891.04,633.41c.26-.17.55-.28.86-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m886.27,636.12c-.5-.07-.88-.51-.88-1.05s.38-.98.88-1.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m891.9,637.06c-.3-.03-.6-.14-.86-.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m895.68,632.72c1.24,0,2.25,1.05,2.25,2.36s-1.01,2.35-2.25,2.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m892.1,636.36c-.68,0-1.23-.57-1.23-1.28s.55-1.28,1.23-1.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m891.04,636.75c-.54-.37-.87-.99-.87-1.67s.33-1.31.87-1.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.32"
					y1="491.49"
					x2="610.72"
					y2="491.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="610.72"
					y1="491.49"
					x2="610.72"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.32"
					y1="482.01"
					x2="627.32"
					y2="546.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.99"
					y1="546.02"
					x2="669.99"
					y2="482.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="669.99"
					y1="482.01"
					x2="605.98"
					y2="482.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.98"
					y1="546.02"
					x2="669.99"
					y2="546.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="607.17"
					y1="482.01"
					x2="607.17"
					y2="546.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="627.32"
					y1="536.54"
					x2="610.72"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="605.98"
					y1="482.01"
					x2="605.98"
					y2="546.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.53"
					y1="629.2"
					x2="428.53"
					y2="624.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="428.53"
					y1="624.51"
					x2="430.9"
					y2="624.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.9"
					y1="624.51"
					x2="430.9"
					y2="629.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="504.98"
					y1="637.5"
					x2="499.14"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.73"
					y1="637.5"
					x2="490.04"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.62"
					y1="637.5"
					x2="480.93"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.52"
					y1="637.5"
					x2="471.83"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.41"
					y1="637.5"
					x2="462.73"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.31"
					y1="637.5"
					x2="453.62"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.21"
					y1="637.5"
					x2="444.52"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="441.11"
					y1="637.5"
					x2="435.42"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="432"
					y1="637.5"
					x2="426.16"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="665.95"
					x2="420.35"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="416.93"
					y1="665.95"
					x2="411.25"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="407.83"
					y1="665.95"
					x2="402.14"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.73"
					y1="665.95"
					x2="393.04"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.63"
					y1="665.95"
					x2="383.94"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.52"
					y1="665.95"
					x2="374.83"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.42"
					y1="665.95"
					x2="365.73"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="362.32"
					y1="665.95"
					x2="356.63"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="353.21"
					y1="665.95"
					x2="347.52"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="344.11"
					y1="665.95"
					x2="338.42"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="335.01"
					y1="665.95"
					x2="329.31"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="325.9"
					y1="665.95"
					x2="320.21"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.8"
					y1="665.95"
					x2="311.11"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="307.7"
					y1="665.95"
					x2="302.01"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="298.59"
					y1="665.95"
					x2="292.9"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="289.49"
					y1="665.95"
					x2="283.8"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="280.39"
					y1="665.95"
					x2="274.57"
					y2="665.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="426.16"
					y1="637.5"
					x2="403.18"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="665.95"
					x2="274.57"
					y2="661.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="657.94"
					x2="274.57"
					y2="652.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="648.84"
					x2="274.57"
					y2="643.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="639.74"
					x2="274.57"
					y2="634.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="630.63"
					x2="274.57"
					y2="624.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="621.53"
					x2="274.57"
					y2="615.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="612.43"
					x2="274.57"
					y2="606.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="603.32"
					x2="274.57"
					y2="597.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="594.22"
					x2="274.57"
					y2="588.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="585.12"
					x2="274.57"
					y2="579.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="576.01"
					x2="274.57"
					y2="570.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="566.91"
					x2="274.57"
					y2="561.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="557.81"
					x2="274.57"
					y2="552.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="548.7"
					x2="274.57"
					y2="543.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="539.6"
					x2="274.57"
					y2="533.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="530.5"
					x2="274.57"
					y2="524.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="521.39"
					x2="274.57"
					y2="515.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="512.29"
					x2="274.57"
					y2="506.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="503.19"
					x2="274.57"
					y2="497.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="494.08"
					x2="274.57"
					y2="488.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="274.57"
					y1="484.98"
					x2="274.57"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.02"
					y1="637.5"
					x2="303.02"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="303.02"
					y1="480.39"
					x2="246.12"
					y2="480.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.06"
					y1="637.5"
					x2="303.02"
					y2="637.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.23"
					y1="162.05"
					x2="319.83"
					y2="162.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.62"
					y1="162.05"
					x2="589.08"
					y2="162.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="717.68"
					y1="162.05"
					x2="873.42"
					y2="162.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="873.42"
					y1="181.01"
					x2="717.68"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.62"
					y1="181.01"
					x2="589.08"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="162.23"
					y1="181.01"
					x2="319.83"
					y2="181.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.88"
					y1="491.49"
					x2="662.88"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="662.88"
					y1="536.54"
					x2="632.06"
					y2="536.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.06"
					y1="536.54"
					x2="632.06"
					y2="491.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.06"
					y1="491.49"
					x2="662.88"
					y2="491.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="920.17 606.99 920.17 651.32 941.01 651.32 941.01 836.77 744.82 836.77 744.82 817.81 752.54 817.81 752.54 802.26 764.4 802.26 764.4 817.81 922.04 817.81 922.04 670.28 901.19 670.28 901.19 599.88 764.4 599.88 764.4 726.4 752.54 726.4 752.54 599.88 589.08 599.88 589.08 543.82 600.93 543.82 600.93 550.54 674.87 550.54 674.87 475.62 600.93 475.62 600.93 482.18 589.08 482.18 589.08 452.44 600.93 452.44 600.93 463.77 686.73 463.77 686.73 510.62 725.31 510.62 725.31 522.47 686.73 522.47 686.73 588.02 931.03 588.02 931.03 522.47 892.45 522.47 892.45 510.62 931.03 510.62 931.03 181.02 873.42 181.02 873.42 162.05 950 162.05 950 606.99 920.17 606.99"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.1"
				/>
				<polygon
					points="654.73 817.81 654.73 836.77 511.88 836.77 511.88 734.47 197.1 734.47 197.1 564.31 50 564.31 50 162.05 162.23 162.05 162.23 181.02 68.97 181.02 68.97 480.39 84.48 480.39 84.48 492.24 68.97 492.24 68.97 545.35 204.21 545.35 204.21 492.24 199.45 492.24 199.45 480.39 246.12 480.39 246.12 694.4 426.16 694.4 426.16 715.5 530.85 715.5 530.85 817.81 654.73 817.81"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.1"
				/>
				<polygon
					points="717.68 162.05 717.68 181.02 678.62 181.02 678.62 269.82 600.93 269.82 600.93 376.59 589.08 376.59 589.08 162.05 717.68 162.05"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.1"
				/>
				<polygon
					points="319.83 181.01 319.83 162.05 446.62 162.05 446.62 181.01 319.83 181.01 319.83 181.01"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.1"
				/>
			</g>
			<g id="text">
				<path d="m264.89,518.05v-11h3.79c.86,0,1.51.05,1.96.16.63.15,1.17.41,1.61.79.58.49,1.01,1.12,1.3,1.88.29.76.44,1.63.44,2.61,0,.83-.1,1.58-.29,2.22-.19.64-.44,1.18-.75,1.6-.3.42-.64.75-1,1-.36.24-.8.42-1.31.55-.51.12-1.1.19-1.76.19h-3.97Zm1.46-1.3h2.35c.73,0,1.29-.07,1.7-.2.42-.14.75-.33.99-.57.34-.35.61-.81.8-1.39.2-.59.29-1.29.29-2.12,0-1.15-.19-2.03-.57-2.65-.37-.62-.83-1.04-1.37-1.24-.39-.15-1.02-.23-1.88-.23h-2.31v8.4Zm11.56,1.3l-2.92-11h1.49l1.67,7.21c.18.76.34,1.51.47,2.25.28-1.17.45-1.85.49-2.03l2.09-7.43h1.76l1.58,5.57c.39,1.38.68,2.68.85,3.89.14-.69.32-1.49.55-2.39l1.72-7.07h1.46l-3.01,11h-1.4l-2.32-8.38c-.19-.7-.31-1.13-.34-1.29-.11.5-.22.94-.32,1.29l-2.33,8.38h-1.49Z" />
				<path d="m462.1,678.94h-1.54l-1.85-3.1c-.17-.29-.33-.53-.49-.73-.16-.21-.32-.37-.49-.5-.16-.13-.34-.22-.54-.28-.19-.06-.41-.09-.65-.09h-1.07v4.71h-1.3v-11.07h3.3c.48,0,.93.06,1.34.19.41.12.77.3,1.07.55.3.25.54.56.71.93.17.37.25.8.25,1.29,0,.39-.06.74-.18,1.07-.11.32-.28.6-.49.86-.21.25-.47.47-.77.65-.3.17-.64.31-1.01.41v.03c.19.08.34.18.48.29.14.1.27.23.39.37.12.14.24.31.36.49.12.18.26.39.41.63l2.08,3.33Zm-6.64-9.9v4.01h1.76c.32,0,.62-.05.9-.15.28-.1.52-.24.72-.42.2-.19.36-.41.47-.67.11-.27.17-.57.17-.9,0-.59-.19-1.05-.58-1.38-.38-.33-.93-.5-1.66-.5h-1.78Zm14.2,6.26h-5.58c.02.88.26,1.56.71,2.04s1.08.72,1.87.72c.89,0,1.71-.29,2.45-.88v1.19c-.69.5-1.61.76-2.76.76s-1.99-.36-2.63-1.07c-.64-.72-.96-1.73-.96-3.03,0-1.23.35-2.23,1.04-3,.7-.78,1.57-1.17,2.6-1.17s1.83.33,2.4,1c.57.67.85,1.6.85,2.79v.66Zm-1.3-1.07c0-.73-.18-1.3-.53-1.71-.34-.41-.83-.61-1.44-.61s-1.1.21-1.52.64c-.42.43-.67.99-.77,1.68h4.27Zm6.98-5.88c-.25-.14-.53-.21-.84-.21-.89,0-1.33.56-1.33,1.68v1.22h1.85v1.08h-1.85v6.82h-1.26v-6.82h-1.35v-1.08h1.35v-1.28c0-.83.24-1.48.72-1.96.48-.48,1.08-.73,1.79-.73.39,0,.69.05.92.14v1.14Z" />
				<path d="m476.68,679.11c-.24,0-.44-.08-.61-.25-.16-.17-.25-.37-.25-.61s.08-.44.25-.61c.17-.17.37-.26.61-.26s.45.09.62.26c.17.17.25.37.25.61s-.08.44-.25.61c-.17.17-.38.25-.62.25Z" />
				<path d="m822.02,749.83v-17.18h4.89c1.49,0,2.66.36,3.54,1.09.87.73,1.31,1.67,1.31,2.84,0,.97-.26,1.82-.79,2.54-.53.72-1.25,1.23-2.18,1.53v.05c1.16.14,2.09.58,2.78,1.32.7.74,1.04,1.69,1.04,2.88,0,1.47-.53,2.66-1.58,3.57-1.05.91-2.38,1.37-3.99,1.37h-5.01Zm2.01-15.36v5.55h2.06c1.1,0,1.97-.26,2.6-.79.63-.54.95-1.29.95-2.25,0-1.67-1.1-2.5-3.3-2.5h-2.31Zm0,7.36v6.18h2.73c1.18,0,2.1-.28,2.74-.84.66-.56.98-1.33.98-2.3,0-2.03-1.38-3.04-4.15-3.04h-2.31Zm20.57,8.01h-1.97v-1.92h-.05c-.85,1.47-2.11,2.21-3.77,2.21-1.22,0-2.18-.32-2.88-.97-.69-.65-1.03-1.51-1.03-2.58,0-2.29,1.35-3.63,4.05-4l3.68-.52c0-2.09-.84-3.13-2.53-3.13-1.48,0-2.81.5-4,1.51v-2.01c1.21-.77,2.6-1.15,4.17-1.15,2.88,0,4.33,1.53,4.33,4.58v7.98Zm-1.97-6.21l-2.96.41c-.91.13-1.6.36-2.06.68-.46.32-.7.89-.7,1.71,0,.6.21,1.09.64,1.47.43.38,1,.56,1.71.56.97,0,1.78-.34,2.41-1.02.64-.69.96-1.55.96-2.6v-1.22Zm11.36,6.09c-.46.26-1.07.38-1.83.38-2.15,0-3.22-1.2-3.22-3.6v-7.26h-2.11v-1.68h2.11v-3l1.97-.64v3.63h3.09v1.68h-3.09v6.91c0,.82.14,1.41.42,1.76.28.35.74.53,1.39.53.5,0,.92-.14,1.28-.41v1.68Zm12.81.12h-1.97v-7.07c0-2.56-.95-3.83-2.85-3.83-.96,0-1.77.37-2.42,1.11-.66.74-.98,1.68-.98,2.84v6.95h-1.97v-18.17h1.97v7.93h.05c.94-1.55,2.28-2.32,4.03-2.32,2.76,0,4.15,1.67,4.15,5v7.56Z" />
				<path d="m670.89,736.92h-9.11v-17.18h8.72v1.82h-6.71v5.72h6.21v1.81h-6.21v6.02h7.09v1.82Zm13.25,0h-1.97v-7c0-2.6-.95-3.91-2.85-3.91-.98,0-1.8.37-2.44,1.11-.64.74-.96,1.67-.96,2.79v7h-1.97v-12.27h1.97v2.04h.05c.93-1.55,2.27-2.32,4.03-2.32,1.34,0,2.37.44,3.08,1.31.71.86,1.07,2.11,1.07,3.75v7.5Zm9.42-.12c-.46.26-1.07.38-1.83.38-2.15,0-3.22-1.2-3.22-3.6v-7.26h-2.11v-1.68h2.11v-3l1.97-.64v3.63h3.09v1.68h-3.09v6.91c0,.82.14,1.41.42,1.76.28.35.74.53,1.39.53.5,0,.92-.14,1.28-.41v1.68Zm9.05-10.16c-.34-.26-.84-.4-1.49-.4-.84,0-1.54.4-2.11,1.19-.56.79-.84,1.87-.84,3.24v6.26h-1.97v-12.27h1.97v2.53h.05c.28-.86.71-1.53,1.28-2.01.58-.49,1.22-.73,1.93-.73.51,0,.9.06,1.17.17v2.04Zm11.93-1.99l-5.64,14.24c-1.01,2.54-2.42,3.81-4.24,3.81-.51,0-.94-.05-1.28-.16v-1.76c.42.14.81.22,1.16.22.99,0,1.73-.59,2.23-1.77l.98-2.32-4.79-12.25h2.18l3.32,9.44c.04.12.12.43.25.93h.07c.04-.19.12-.5.24-.91l3.49-9.47h2.04Z" />
				<path d="m724.53,339.04v-17.18h4.89c1.49,0,2.66.36,3.54,1.09.87.73,1.31,1.67,1.31,2.84,0,.97-.26,1.82-.79,2.54-.53.72-1.25,1.23-2.18,1.53v.05c1.16.14,2.09.58,2.78,1.32.7.74,1.04,1.69,1.04,2.88,0,1.47-.53,2.66-1.58,3.57-1.05.91-2.38,1.37-3.99,1.37h-5.01Zm2.01-15.36v5.55h2.06c1.1,0,1.97-.26,2.6-.79.63-.54.95-1.29.95-2.25,0-1.67-1.1-2.5-3.3-2.5h-2.31Zm0,7.36v6.18h2.73c1.18,0,2.1-.28,2.74-.84.66-.56.98-1.33.98-2.3,0-2.03-1.38-3.04-4.15-3.04h-2.31Zm21.63,2.36h-8.66c.03,1.37.4,2.42,1.1,3.16.7.74,1.67,1.11,2.9,1.11,1.38,0,2.65-.46,3.81-1.37v1.85c-1.08.78-2.5,1.17-4.28,1.17s-3.1-.56-4.09-1.67c-.99-1.12-1.49-2.69-1.49-4.71,0-1.91.54-3.46,1.62-4.66,1.09-1.21,2.43-1.81,4.04-1.81s2.85.52,3.73,1.56c.88,1.04,1.32,2.48,1.32,4.33v1.03Zm-2.01-1.67c0-1.13-.28-2.02-.83-2.65-.54-.63-1.28-.95-2.24-.95s-1.71.33-2.36.99c-.65.66-1.05,1.53-1.2,2.6h6.63Zm15.44,7.31h-1.97v-2.09h-.05c-.91,1.58-2.32,2.37-4.22,2.37-1.54,0-2.78-.55-3.7-1.64-.92-1.1-1.38-2.6-1.38-4.49,0-2.03.51-3.66,1.53-4.88,1.02-1.22,2.38-1.83,4.09-1.83s2.91.66,3.68,1.99h.05v-7.6h1.97v18.17Zm-1.97-5.55v-1.81c0-.99-.33-1.83-.98-2.52s-1.49-1.03-2.49-1.03c-1.2,0-2.14.44-2.83,1.32-.69.88-1.03,2.09-1.03,3.64,0,1.41.33,2.53.98,3.36.66.81,1.55,1.22,2.66,1.22s1.98-.4,2.66-1.19c.69-.79,1.03-1.79,1.03-3Zm12.33-4.73c-.34-.26-.84-.4-1.49-.4-.84,0-1.54.4-2.11,1.19-.56.79-.84,1.87-.84,3.24v6.26h-1.97v-12.27h1.97v2.53h.05c.28-.86.71-1.53,1.28-2.01.58-.49,1.22-.73,1.93-.73.51,0,.9.06,1.17.17v2.04Zm7.25,10.57c-1.81,0-3.26-.57-4.35-1.71-1.08-1.15-1.62-2.67-1.62-4.57,0-2.06.56-3.67,1.69-4.83s2.65-1.74,4.57-1.74,3.26.56,4.28,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.71c-1.1,1.17-2.58,1.76-4.45,1.76Zm.14-11.19c-1.26,0-2.26.43-3,1.29-.74.85-1.1,2.04-1.1,3.55s.37,2.6,1.11,3.44c.74.84,1.74,1.26,2.98,1.26s2.24-.41,2.92-1.23c.69-.82,1.03-1.99,1.03-3.51s-.34-2.72-1.03-3.55c-.68-.83-1.65-1.25-2.92-1.25Zm14.22,11.19c-1.81,0-3.26-.57-4.35-1.71-1.08-1.15-1.62-2.67-1.62-4.57,0-2.06.56-3.67,1.69-4.83,1.13-1.16,2.65-1.74,4.57-1.74s3.26.56,4.28,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.71c-1.1,1.17-2.58,1.76-4.45,1.76Zm.14-11.19c-1.26,0-2.26.43-3,1.29-.74.85-1.1,2.04-1.1,3.55s.37,2.6,1.11,3.44c.74.84,1.74,1.26,2.98,1.26s2.24-.41,2.92-1.23c.69-.82,1.03-1.99,1.03-3.51s-.34-2.72-1.03-3.55c-.68-.83-1.65-1.25-2.92-1.25Zm26.51,10.91h-1.97v-7.05c0-1.36-.21-2.34-.64-2.95-.42-.61-1.12-.91-2.11-.91-.84,0-1.55.38-2.15,1.15-.58.77-.87,1.69-.87,2.76v7h-1.97v-7.29c0-2.41-.93-3.62-2.79-3.62-.86,0-1.57.36-2.13,1.09-.56.72-.84,1.66-.84,2.82v7h-1.97v-12.27h1.97v1.94h.05c.87-1.49,2.14-2.23,3.81-2.23.84,0,1.57.24,2.19.71.62.46,1.05,1.07,1.28,1.83.91-1.69,2.27-2.54,4.07-2.54,2.7,0,4.05,1.67,4.05,5v7.56Z" />
				<path d="m729.44,364.51h-1.43v-10.8c-.11.11-.27.24-.49.38-.21.14-.45.28-.71.42-.26.14-.54.27-.84.39-.29.12-.58.22-.85.29v-1.45c.31-.09.64-.2.99-.35.35-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.78-.59h.54v12.78Zm9.64,0h-1.43v-10.8c-.11.11-.27.24-.49.38-.21.14-.45.28-.71.42-.26.14-.54.27-.84.39-.29.12-.58.22-.85.29v-1.45c.31-.09.64-.2.99-.35.35-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.78-.59h.54v12.78Z" />
				<rect x="743.83" y="352.02" width="1.26" height="3.9" />
				<path d="m755.25,352.85c-.19.33-.42.74-.7,1.24-.27.49-.55,1.05-.85,1.66s-.61,1.28-.92,1.99c-.31.71-.61,1.44-.88,2.2-.27.76-.51,1.52-.72,2.3-.2.77-.35,1.53-.44,2.28h-1.53c.1-.74.26-1.5.48-2.27.22-.78.47-1.54.74-2.28.28-.75.57-1.47.88-2.16.31-.69.61-1.33.9-1.91.29-.58.55-1.09.79-1.53.24-.45.44-.8.58-1.05h-6.27v-1.29h7.95v.83Z" />
				<path d="m758.77,352.02v3.9h-1.26v-3.9h1.26Zm2.89,0v3.9h-1.26v-3.9h1.26Z" />
				<path d="m775.96,355.59l-3,4.51,2.95,4.41h-1.66l-1.75-2.89c-.11-.18-.24-.41-.39-.68h-.03c-.03.05-.17.28-.41.68l-1.79,2.89h-1.65l3.04-4.37-2.91-4.55h1.66l1.73,3.05c.13.23.25.46.37.7h.03l2.23-3.75h1.58Z" />
				<path d="m787.39,364.51h-1.43v-10.8c-.11.11-.27.24-.49.38-.21.14-.45.28-.71.42-.26.14-.54.27-.84.39-.29.12-.58.22-.85.29v-1.45c.31-.09.64-.2.99-.35.35-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.78-.59h.54v12.78Zm9.64,0h-1.43v-10.8c-.11.11-.27.24-.49.38-.21.14-.45.28-.71.42-.26.14-.54.27-.84.39-.29.12-.58.22-.85.29v-1.45c.31-.09.64-.2.99-.35.35-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.78-.59h.54v12.78Z" />
				<rect x="801.78" y="352.02" width="1.26" height="3.9" />
				<path d="m805.19,361.03c0-.33.05-.66.16-.99.1-.34.25-.65.44-.94.2-.29.44-.55.72-.79.29-.24.62-.43.98-.57-.54-.3-.97-.69-1.29-1.16-.32-.48-.48-1-.48-1.58,0-.46.09-.88.26-1.27.18-.39.43-.73.74-1.01.31-.28.69-.51,1.12-.66.43-.16.89-.24,1.39-.24s.97.08,1.4.24c.43.16.8.39,1.12.67.31.28.56.62.73,1.01s.26.81.26,1.26c0,.58-.16,1.1-.48,1.58-.32.47-.74.86-1.27,1.16.36.14.68.33.97.57.28.24.52.5.71.79.2.29.35.6.45.94.1.33.16.66.16.99,0,.55-.1,1.05-.3,1.5-.2.45-.48.84-.84,1.17-.35.32-.78.57-1.28.75-.49.18-1.04.27-1.64.27s-1.14-.09-1.63-.27c-.49-.18-.92-.43-1.28-.75-.36-.33-.64-.71-.85-1.17-.2-.45-.3-.95-.3-1.5Zm1.55-.12c0,.39.06.74.17,1.05.12.31.29.58.51.8.22.22.49.39.79.51.31.12.66.17,1.04.17s.7-.06,1.01-.18c.31-.12.57-.29.79-.51.23-.22.4-.49.52-.8.13-.31.19-.66.19-1.05,0-.35-.06-.67-.18-.98-.12-.31-.28-.58-.51-.81-.22-.23-.49-.42-.79-.55-.31-.13-.65-.2-1.04-.2-.36,0-.69.06-1,.19-.3.12-.57.3-.79.52-.22.22-.4.49-.52.8-.13.31-.19.65-.19,1.02Zm.44-5.8c0,.3.05.57.16.83.11.25.26.47.44.66.19.19.41.33.66.44.25.1.52.16.8.16s.55-.06.8-.17c.26-.11.48-.26.66-.44.19-.19.33-.41.44-.66.11-.26.17-.53.17-.82s-.06-.58-.17-.84c-.1-.26-.25-.48-.44-.66-.19-.19-.41-.33-.66-.44-.25-.11-.52-.17-.81-.17-.31,0-.59.06-.85.17-.25.11-.47.26-.65.45-.18.19-.32.41-.42.66-.1.26-.15.53-.15.82Z" />
				<path d="m816.73,352.02v3.9h-1.26v-3.9h1.26Zm2.89,0v3.9h-1.26v-3.9h1.26Z" />
				<path d="m374.99,565.39h-2.8l-6.64-7.86c-.25-.3-.4-.5-.46-.6h-.05v8.46h-2.01v-17.18h2.01v8.08h.05c.11-.18.26-.37.46-.59l6.42-7.49h2.5l-7.37,8.24,7.89,8.94Zm3-15.39c-.35,0-.65-.12-.9-.36-.25-.24-.37-.54-.37-.91s.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.39h-1.97v-12.27h1.97v12.27Zm9.65-.12c-.46.26-1.07.38-1.83.38-2.15,0-3.22-1.2-3.22-3.6v-7.26h-2.11v-1.68h2.11v-3l1.97-.64v3.63h3.09v1.68h-3.09v6.91c0,.82.14,1.41.42,1.76.28.35.74.53,1.39.53.5,0,.92-.14,1.28-.41v1.68Zm10.98-.44c-.94.57-2.06.85-3.36.85-1.75,0-3.16-.57-4.24-1.7-1.07-1.14-1.61-2.62-1.61-4.43,0-2.02.58-3.64,1.74-4.87,1.16-1.23,2.7-1.85,4.64-1.85,1.08,0,2.03.2,2.85.6v2.01c-.91-.64-1.89-.96-2.92-.96-1.25,0-2.28.45-3.09,1.35-.8.89-1.2,2.07-1.2,3.54s.38,2.57,1.13,3.4c.76.83,1.77,1.25,3.04,1.25,1.07,0,2.08-.36,3.02-1.07v1.87Zm13.14.56h-1.97v-7.07c0-2.56-.95-3.83-2.85-3.83-.96,0-1.77.37-2.42,1.11-.66.74-.98,1.68-.98,2.84v6.95h-1.97v-18.17h1.97v7.93h.05c.94-1.55,2.28-2.32,4.03-2.32,2.76,0,4.15,1.67,4.15,5v7.56Zm13.55-5.64h-8.66c.03,1.37.4,2.42,1.1,3.16.7.74,1.67,1.11,2.9,1.11,1.38,0,2.65-.46,3.81-1.37v1.85c-1.08.78-2.5,1.17-4.28,1.17s-3.1-.56-4.09-1.67c-.99-1.12-1.49-2.69-1.49-4.71,0-1.91.54-3.46,1.62-4.66,1.09-1.21,2.43-1.81,4.04-1.81s2.85.52,3.73,1.56c.88,1.04,1.32,2.48,1.32,4.33v1.03Zm-2.01-1.67c0-1.13-.28-2.02-.83-2.65-.54-.63-1.28-.95-2.24-.95s-1.71.33-2.36.99c-.65.66-1.05,1.53-1.2,2.6h6.63Zm15.16,7.31h-1.97v-7c0-2.6-.95-3.91-2.85-3.91-.98,0-1.8.37-2.44,1.11-.64.74-.96,1.67-.96,2.79v7h-1.97v-12.27h1.97v2.04h.05c.93-1.55,2.27-2.32,4.03-2.32,1.34,0,2.37.44,3.08,1.31.71.86,1.07,2.11,1.07,3.75v7.5Z" />
				<path d="m239.61,324.75h-8.92v-17.18h2.01v15.36h6.9v1.82Zm3.38-15.39c-.35,0-.65-.12-.9-.36-.25-.24-.37-.54-.37-.91s.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.39h-1.97v-12.27h1.97v12.27Zm13.61-12.27l-4.89,12.27h-1.93l-4.65-12.27h2.16l3.12,8.92c.23.66.38,1.23.43,1.71h.05c.08-.62.21-1.17.38-1.67l3.26-8.96h2.07Zm3.11-3.12c-.35,0-.65-.12-.9-.36-.25-.24-.37-.54-.37-.91s.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.39h-1.97v-12.27h1.97v12.27Zm14.15,0h-1.97v-7c0-2.6-.95-3.91-2.85-3.91-.98,0-1.8.37-2.44,1.11-.64.74-.96,1.67-.96,2.79v7h-1.97v-12.27h1.97v2.04h.05c.93-1.55,2.27-2.32,4.03-2.32,1.34,0,2.37.44,3.08,1.31.71.86,1.07,2.11,1.07,3.75v7.5Zm14.17-.98c0,4.51-2.16,6.76-6.47,6.76-1.52,0-2.84-.29-3.98-.86v-1.97c1.38.77,2.7,1.15,3.95,1.15,3.02,0,4.53-1.61,4.53-4.82v-1.34h-.05c-.93,1.57-2.34,2.35-4.22,2.35-1.53,0-2.76-.54-3.69-1.63-.93-1.09-1.39-2.56-1.39-4.4,0-2.09.5-3.74,1.5-4.97,1.01-1.23,2.38-1.85,4.12-1.85s2.88.66,3.68,1.99h.05v-1.7h1.97v11.29Zm-1.97-4.57v-1.81c0-.97-.33-1.81-.99-2.5-.66-.7-1.47-1.04-2.46-1.04-1.21,0-2.17.44-2.85,1.33-.69.88-1.03,2.11-1.03,3.7,0,1.37.33,2.46.98,3.28.66.81,1.54,1.22,2.62,1.22s2-.39,2.68-1.17c.7-.78,1.04-1.79,1.04-3.01Z" />
				<polygon points="301.67 307.56 293.42 327.6 291.59 327.6 299.81 307.56 301.67 307.56" />
				<path d="m303.67,324.75v-17.18h4.75c6.06,0,9.08,2.79,9.08,8.38,0,2.65-.84,4.79-2.53,6.4-1.68,1.61-3.93,2.41-6.75,2.41h-4.55Zm2.01-15.36v13.54h2.56c2.25,0,4.01-.6,5.26-1.81,1.25-1.21,1.88-2.92,1.88-5.13,0-4.4-2.34-6.6-7.02-6.6h-2.68Zm15.86-.02c-.35,0-.65-.12-.9-.36-.25-.24-.37-.54-.37-.91s.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.39h-1.97v-12.27h1.97v12.27Zm14.09,0h-1.97v-7c0-2.6-.95-3.91-2.85-3.91-.98,0-1.8.37-2.44,1.11-.64.74-.96,1.67-.96,2.79v7h-1.97v-12.27h1.97v2.04h.05c.93-1.55,2.27-2.32,4.03-2.32,1.34,0,2.37.44,3.08,1.31.71.86,1.07,2.11,1.07,3.75v7.5Zm4.64-15.39c-.35,0-.65-.12-.9-.36s-.37-.54-.37-.91.12-.67.37-.91c.25-.25.55-.37.9-.37s.66.12.91.37c.26.24.38.54.38.91s-.13.65-.38.9c-.25.25-.55.37-.91.37Zm.96,15.39h-1.97v-12.27h1.97v12.27Zm14.09,0h-1.97v-7c0-2.6-.95-3.91-2.85-3.91-.98,0-1.8.37-2.44,1.11-.64.74-.96,1.67-.96,2.79v7h-1.97v-12.27h1.97v2.04h.05c.93-1.55,2.27-2.32,4.03-2.32,1.34,0,2.37.44,3.08,1.31.71.86,1.07,2.11,1.07,3.75v7.5Zm14.1-.98c0,4.51-2.16,6.76-6.47,6.76-1.52,0-2.84-.29-3.98-.86v-1.97c1.38.77,2.7,1.15,3.95,1.15,3.02,0,4.53-1.61,4.53-4.82v-1.34h-.05c-.93,1.57-2.34,2.35-4.22,2.35-1.53,0-2.76-.54-3.69-1.63-.93-1.09-1.39-2.56-1.39-4.4,0-2.09.5-3.74,1.5-4.97,1.01-1.23,2.38-1.85,4.12-1.85s2.88.66,3.68,1.99h.05v-1.7h1.97v11.29Zm-1.97-4.57v-1.81c0-.97-.33-1.81-.99-2.5-.66-.7-1.47-1.04-2.46-1.04-1.21,0-2.17.44-2.85,1.33-.69.88-1.03,2.11-1.03,3.7,0,1.37.33,2.46.98,3.28.66.81,1.54,1.22,2.62,1.22s2-.39,2.68-1.17c.7-.78,1.04-1.79,1.04-3.01Z" />
				<path d="m393.87,324.75h-2.4l-2.88-4.82c-.26-.45-.52-.83-.77-1.14-.25-.32-.5-.58-.77-.78-.26-.2-.54-.34-.84-.43-.3-.1-.63-.14-1.01-.14h-1.65v7.31h-2.01v-17.18h5.13c.75,0,1.44.1,2.07.29.64.18,1.19.47,1.65.85.47.38.84.86,1.1,1.44.26.57.4,1.23.4,2,0,.6-.09,1.15-.28,1.65-.18.5-.43.94-.77,1.33-.33.39-.73.73-1.2,1.01-.46.27-.99.48-1.57.64v.05c.29.13.54.28.74.44.22.16.42.35.61.58.19.22.38.48.56.77.19.28.4.61.64.98l3.22,5.16Zm-10.31-15.36v6.23h2.73c.5,0,.97-.08,1.39-.23.43-.15.8-.37,1.11-.65.31-.29.56-.64.73-1.04.18-.42.26-.88.26-1.39,0-.92-.3-1.63-.9-2.15-.59-.52-1.45-.78-2.58-.78h-2.76Zm17.45,15.65c-1.81,0-3.26-.57-4.35-1.71-1.08-1.15-1.62-2.67-1.62-4.57,0-2.06.56-3.67,1.69-4.83,1.13-1.16,2.65-1.74,4.57-1.74s3.26.56,4.28,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.71c-1.1,1.17-2.58,1.76-4.45,1.76Zm.14-11.19c-1.26,0-2.26.43-3,1.29-.74.85-1.1,2.04-1.1,3.55s.37,2.6,1.11,3.44c.74.84,1.74,1.26,2.98,1.26s2.24-.41,2.92-1.23c.69-.82,1.03-1.99,1.03-3.51s-.34-2.72-1.03-3.55c-.68-.83-1.65-1.25-2.92-1.25Zm14.16,11.19c-1.81,0-3.26-.57-4.35-1.71-1.08-1.15-1.62-2.67-1.62-4.57,0-2.06.56-3.67,1.69-4.83,1.13-1.16,2.65-1.74,4.57-1.74s3.26.56,4.28,1.69c1.03,1.13,1.55,2.69,1.55,4.69s-.56,3.53-1.67,4.71c-1.1,1.17-2.58,1.76-4.45,1.76Zm.14-11.19c-1.26,0-2.26.43-3,1.29-.73.85-1.1,2.04-1.1,3.55s.37,2.6,1.11,3.44c.74.84,1.74,1.26,2.98,1.26s2.24-.41,2.92-1.23c.69-.82,1.03-1.99,1.03-3.51s-.34-2.72-1.03-3.55c-.68-.83-1.65-1.25-2.92-1.25Zm26.46,10.91h-1.97v-7.05c0-1.36-.21-2.34-.64-2.95-.42-.61-1.12-.91-2.11-.91-.84,0-1.55.38-2.15,1.15-.58.77-.87,1.69-.87,2.76v7h-1.97v-7.29c0-2.41-.93-3.62-2.79-3.62-.86,0-1.57.36-2.13,1.09-.56.72-.84,1.66-.84,2.82v7h-1.97v-12.27h1.97v1.94h.05c.87-1.49,2.14-2.23,3.81-2.23.84,0,1.57.24,2.19.71.62.46,1.05,1.07,1.28,1.83.91-1.69,2.27-2.54,4.07-2.54,2.7,0,4.05,1.67,4.05,5v7.56Z" />
				<path d="m293.2,350.22h-1.43v-10.8c-.11.11-.27.24-.49.38-.21.14-.45.28-.71.42-.26.14-.54.27-.84.39-.29.12-.58.22-.85.29v-1.45c.31-.09.64-.2.99-.35.35-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.78-.59h.54v12.78Zm4.11-3.49c0-.33.05-.66.16-.99.1-.34.25-.65.44-.94.2-.29.44-.55.72-.79.29-.24.62-.43.98-.57-.54-.3-.97-.69-1.29-1.16-.32-.48-.48-1-.48-1.58,0-.46.09-.88.26-1.27.18-.39.43-.73.74-1.01.31-.28.69-.51,1.12-.66.43-.16.89-.24,1.39-.24s.97.08,1.4.24c.43.16.8.39,1.12.67.31.28.56.62.73,1.01s.26.81.26,1.26c0,.58-.16,1.1-.48,1.58-.32.47-.74.86-1.27,1.16.36.14.68.33.97.57.28.24.52.5.71.79.2.29.35.6.45.94.1.33.16.66.16.99,0,.55-.1,1.05-.3,1.5-.2.45-.48.84-.84,1.17-.35.32-.78.57-1.28.75-.49.18-1.04.27-1.64.27s-1.14-.09-1.63-.27c-.49-.18-.92-.43-1.28-.75-.36-.33-.64-.71-.85-1.17-.2-.45-.3-.95-.3-1.5Zm1.55-.12c0,.39.06.74.17,1.05.12.31.29.58.51.8.22.22.49.39.79.51.31.12.66.17,1.04.17s.7-.06,1.01-.18.57-.29.79-.51c.23-.22.4-.49.52-.8.13-.31.19-.66.19-1.05,0-.35-.06-.67-.18-.98-.12-.31-.28-.58-.51-.81-.22-.23-.49-.42-.79-.55-.31-.13-.65-.2-1.04-.2-.36,0-.69.06-1,.19-.3.12-.57.3-.79.52-.22.22-.4.49-.52.8-.13.31-.19.65-.19,1.02Zm.44-5.8c0,.3.05.57.16.83.11.25.26.47.44.66.19.19.41.33.66.44.25.1.52.16.8.16s.55-.06.8-.17c.26-.11.48-.26.66-.44.19-.19.33-.41.44-.66.11-.26.17-.53.17-.82s-.06-.58-.17-.84c-.1-.26-.25-.48-.44-.66-.19-.19-.41-.33-.66-.44-.25-.11-.52-.17-.81-.17-.31,0-.59.06-.85.17-.25.11-.47.26-.65.45-.18.19-.32.41-.42.66-.1.26-.15.53-.15.82Z" />
				<rect x="307.59" y="337.72" width="1.26" height="3.9" />
				<path d="m318.52,346.68c0,.56-.11,1.08-.32,1.54-.21.46-.51.85-.9,1.19-.38.33-.85.58-1.39.76-.54.18-1.14.27-1.79.27-1.19,0-2.14-.23-2.84-.68v-1.53c.84.66,1.81.99,2.89.99.44,0,.83-.06,1.18-.17.35-.11.66-.27.91-.48.26-.21.45-.46.58-.76.14-.3.21-.63.21-1,0-1.63-1.16-2.45-3.49-2.45h-1.04v-1.21h.98c2.06,0,3.09-.77,3.09-2.3,0-1.42-.78-2.13-2.35-2.13-.88,0-1.71.3-2.48.89v-1.39c.8-.48,1.74-.71,2.84-.71.52,0,1,.07,1.42.22.42.15.79.35,1.09.61.3.26.53.58.7.94.17.37.25.77.25,1.21,0,1.64-.83,2.7-2.49,3.17v.03c.42.05.82.15,1.18.31.36.16.67.36.93.62.26.26.46.56.61.91.15.34.23.72.23,1.14Z" />
				<path d="m322.54,337.72v3.9h-1.26v-3.9h1.26Zm2.89,0v3.9h-1.26v-3.9h1.26Z" />
				<path d="m339.72,341.3l-3,4.51,2.95,4.41h-1.66l-1.75-2.89c-.11-.18-.24-.41-.39-.68h-.03c-.03.05-.17.28-.41.68l-1.79,2.89h-1.65l3.04-4.37-2.91-4.55h1.66l1.73,3.05c.13.23.25.46.37.7h.03l2.23-3.75h1.58Z" />
				<path d="m351.15,350.22h-1.43v-10.8c-.11.11-.27.24-.49.38-.21.14-.45.28-.71.42-.26.14-.54.27-.84.39-.29.12-.58.22-.85.29v-1.45c.31-.09.64-.2.99-.35.35-.15.7-.32,1.04-.5.34-.19.67-.38.97-.58.3-.2.56-.4.78-.59h.54v12.78Zm12.22-6.3c0,1.05-.1,1.97-.29,2.78-.19.81-.46,1.49-.82,2.05-.35.55-.79.97-1.32,1.26-.52.28-1.11.43-1.77.43-.63,0-1.19-.14-1.68-.41-.49-.28-.9-.68-1.24-1.21-.34-.53-.59-1.18-.77-1.94-.17-.77-.26-1.66-.26-2.65,0-1.09.09-2.06.27-2.89.19-.84.46-1.54.81-2.1.35-.57.79-1,1.32-1.28.53-.29,1.13-.44,1.81-.44,2.62,0,3.93,2.14,3.93,6.41Zm-1.46.14c0-3.56-.85-5.33-2.54-5.33-1.78,0-2.68,1.81-2.68,5.43,0,3.38.87,5.06,2.62,5.06s2.59-1.72,2.59-5.16Z" />
				<rect x="365.54" y="337.72" width="1.26" height="3.9" />
				<path d="m377.07,346.26c0,.61-.1,1.17-.3,1.68-.2.51-.47.95-.82,1.32-.35.37-.76.66-1.25.87-.48.2-1.01.31-1.57.31-.63,0-1.19-.13-1.69-.39-.49-.26-.92-.64-1.26-1.12-.34-.49-.6-1.1-.78-1.8-.18-.71-.27-1.51-.27-2.4,0-1.09.12-2.07.36-2.95.24-.89.59-1.65,1.03-2.27.45-.63.98-1.12,1.61-1.46s1.33-.51,2.1-.51c.86,0,1.55.12,2.07.36v1.35c-.64-.33-1.32-.5-2.04-.5-.56,0-1.06.12-1.51.37-.45.25-.83.6-1.15,1.06-.32.45-.57,1-.74,1.65-.17.64-.25,1.36-.25,2.15h.03c.58-1.04,1.53-1.56,2.85-1.56.55,0,1.04.09,1.47.28.44.19.82.45,1.12.79.31.34.55.74.72,1.21s.25.99.25,1.57Zm-1.46.18c0-.44-.06-.83-.17-1.18-.11-.35-.27-.64-.48-.89-.2-.24-.46-.43-.76-.56-.3-.13-.64-.2-1.03-.2-.35,0-.68.07-.98.2-.3.13-.56.32-.78.55-.22.23-.4.49-.52.8-.12.3-.18.62-.18.97,0,.43.06.83.18,1.21.12.37.29.7.51.98s.48.5.78.66c.31.16.65.24,1.02.24s.69-.07.98-.2c.3-.14.55-.33.76-.58.21-.24.37-.53.49-.87.12-.34.17-.72.17-1.13Z" />
				<path d="m380.49,337.72v3.9h-1.26v-3.9h1.26Zm2.89,0v3.9h-1.26v-3.9h1.26Z" />
				<path d="m646.2,509.9l-2.87,10.16h-1.4l-2.09-7.42c-.09-.32-.14-.66-.16-1.03h-.03c-.03.35-.09.69-.18,1.02l-2.1,7.44h-1.38l-2.98-10.16h1.31l2.16,7.79c.09.33.15.67.17,1.02h.04c.02-.25.1-.59.22-1.02l2.25-7.79h1.14l2.15,7.85c.08.27.13.59.17.95h.03c.02-.25.08-.57.19-.98l2.08-7.82h1.29Z" />
				<polygon points="652.12 509.9 647.24 521.74 646.16 521.74 651.02 509.9 652.12 509.9" />
				<path d="m653.3,520.06v-10.16h2.81c3.58,0,5.37,1.65,5.37,4.95,0,1.57-.5,2.83-1.49,3.78-.99.95-2.32,1.42-3.99,1.42h-2.69Zm1.19-9.08v8.01h1.52c1.33,0,2.37-.36,3.11-1.07.74-.71,1.11-1.72,1.11-3.03,0-2.6-1.38-3.9-4.15-3.9h-1.59Z" />
			</g>
		</g>
	)
}

export default PlanP
